<template>
	<div style="height: 100%" :tabindex="tabindex" @focus="table_Focused">
		<div style="position:relative" :style="maxHeight > 0 ? { maxHeight: maxHeight + 'px' } : ''" :data-grid-id="gridId" :class="{
			'nk-full-screen': fullScreenStatus,
			[`grid_${gridId}`]: true,
			grid: true,
			ltr: settings.ltr,
			'stop-user-select': stopUserSelectOnTable,
			readonly: !isEditable,
		}">
			<div ref="grid_buttons" tabindex="0" class="grid-buttons text-right">
				<component :is="button.type" v-for="button in settings.computedButtons" :key="button.id" :class="button.class" @click="button.handler" @submit="button.handler" :options="button.options" class="m-1" />
			</div>
			<div class="grid-mainbar" id="gridMinbar" ref="gridMinbar">
				<nk-popup v-if="templatesIsOpen" ref="templatePopup" :options="templatesOptions" @resolve="templates_selectedChanged" @close-button-clicked="templates_buttonClicked" class="template-popup"></nk-popup>
				<div :class="{
					'grid-col-indicator': true,
					enabled: settings.colIndicatorBarEnabled,
				}" ref="grid-col-indicator"></div>
				<div style="min-height:140px;overflow:auto;position:relative;height:100%" :style="{ 'padding-bottom': pb }" class="scroller" ref="scroller">
					<table style="width: 100%;">
						<thead class="grid-head" ref="head" style="z-index: 3">
							<tr class="grid-row grid-head-row" v-if="headerCategoryLength > 0">
								<th :data-grid-id="gridId" class="grid-cell indicator frozen fixed" style="order: 1" data-distance="0">
									<div class="grid-cell-content grid-cell-sizer"></div>
								</th>
								<th :data-grid-id="gridId" v-if="settings.checkboxesEnabled" class="grid-cell checkbox frozen fixed" @click="row_headerCheckboxClicked" style="order: 2" data-distance="0">
									<div class="grid-cell-content grid-cell-sizer" :style="'color: ' + headerCheckboxValue.color + ';'">
										<icon :icon="headerCheckboxValue.icon" />
									</div>
								</th>
								<th :data-grid-id="gridId" v-for="headerCategory of headerCategories" :key="headerCategory.col.id" :colspan="headerCategory.colspan" :class="{
									'grid-cell': true,
								}">
									<div class="grid-cell-content justify-content-center">
										{{ headerCategory.col.headerCategory }}
									</div>
								</th>
							</tr>
							<tr class="grid-row grid-head-row">
								<th :data-grid-id="gridId" class="grid-cell indicator frozen fixed" data-id="rowIndicator" style="order: 1" data-distance="0">
									<div class="grid-cell-content grid-cell-sizer">
										<GridSettings v-if="settings.gridSettingsEnabled" :permissions="settingPermissions" @change-visibility="changeVisibility" @aggregate-row-visibility="aggregateRowVisibility" @filter-row-visibility="filterRowVisibility" @templates-button-clicked="templates_buttonClicked" :buttons="settingButtons" :filteredColumns="filteredColumns" :filteredData="localValue.length > 1 ? localValue : filteredData" :stateUID="settings.stateUID" :filterRowChecked="settings.searchBarEnabled"
											:aggregateRowChecked="settings.aggregatesEnabled" />
									</div>
								</th>
								<th :data-grid-id="gridId" v-if="settings.checkboxesEnabled" class="grid-cell checkbox frozen fixed" data-id="rowCheckbox" style="order: 2" data-distance="0">
									<div class="grid-cell-content grid-cell-sizer" :style="'color: ' + headerCheckboxValue.color + ';'">
										<GridSelectMenu :icon="headerCheckboxValue.icon" @row_headerCheckboxClicked="row_headerCheckboxClicked" @value_addAll="menu_addAll" @value_removeAll="menu_removeAll" @value_reverse="value_reverse" />
									</div>
								</th>
								<th :data-grid-id="gridId" v-for="col of filteredColumns" :key="col.id" :data-id="col.id" :class="{
									'grid-cell': true,
									frozen: col.pinned,
									fixed: !col.draggable,
									'reverse-dir': col.reverseDir,
									'col-active': col.isActive,
									'col-sorted': col.sortState !== 'none',
								}" :style="'order: ' +
									col.order +
									';' +
									col.minmaxStyle +
									';width: ' +
									col.width +
									';' +
									(!col.visibility ? 'display: none' : 'display: table-cell')
									" :data-distance="col.$___distance > -1 ? col.$___distance : null
										">
									<div :class="{
										'grid-cell-content': true,
										'grid-cell-sizer': col.resizable,
									}" :style="[
										col.width == 'auto'
											? {
												'white-space': 'pre',
												'min-width': '100%',
												width: col.width,
											}
											: { 'min-width': '100%', width: col.width },
									]">
										<div :class="{ lock: true, locked: col.pinned, visible: col.pinnable, 'opacity-1': col.pinned }" @click="col_pin(col)">
											<icon :icon="col.pinned
												? ['fas', 'fa-lock']
												: ['fal', 'fa-lock-open']
												" />
										</div>
										<div class="grid-cell-content-view text-center" @click="col_isSortable(col) ? sort_toggle(col) : ''" v-html="col.title"></div>
										<div :class="[{ visible: col_isSortable(col), 'opacity-1': col.sortState !== 'none' }, 'th-sort ml-2']" @click="sort_toggle(col)">
											<icon v-if="col.sortState === 'none'" icon="sort" />
											<icon v-if="col.sortState === 'desc'" icon="sort-up" />
											<icon v-if="col.sortState === 'asc'" icon="sort-down" />
										</div>
										<div v-if="col.droppable" class="dropzone"></div>
										<div v-if="col.resizable" class="sizer-handle"></div>
									</div>
								</th>
							</tr>
							<tr v-if="settings.searchBarEnabled" class="grid-row grid-search-row" ref="search-row">
								<th :data-grid-id="gridId" class="grid-cell indicator frozen fixed" data-id="rowIndicator" style="order: 1" data-distance="0">
									<div class="grid-cell-content" v-if="searchedCols.length <= 0">
										<div class="icon">
											<icon icon="search" />
										</div>
									</div>
									<div class="grid-cell-content" v-else style="cursor: pointer" @click="removeAllFilter">
										<div class="icon">
											<icon icon="fad fa-times-circle" />
										</div>
									</div>
								</th>
								<th :data-grid-id="gridId" v-if="settings.checkboxesEnabled" class="grid-cell checkbox frozen fixed" data-id="rowCheckbox" style="order: 2" data-distance="0">
									<div class="grid-cell-content"></div>
								</th>
								<th :data-grid-id="gridId" v-for="col of filteredColumns" :key="col.id" :data-id="col.id" :class="{
									'grid-cell': true,
									frozen: col.pinned,
									fixed: !col.draggable,
									'col-active': col.isActive,
									'reverse-dir': col.reverseDir,
								}" :style="'order: ' +
									col.order +
									';' +
									(!col.visibility ? 'display: none' : 'display: table-cell')
									" :data-distance="col.$___distance > -1 ? col.$___distance : null
										">
									<div class="grid-cell-content">
										<div class="input-container">
											<FilterRow @remove-grid-filter="removeAllFilter" :col="col" :filteredData="filteredData" @select-filter-mode="selectFilterMode" @search-blur="searchBlur" @remove-filter="removeFilter" ref="filterRows"></FilterRow>
										</div>
									</div>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr class="no-data" ref="nodata" :class="noDataClass" v-show="filteredData.length == 0">
								<td :colspan="filteredColumns.length + (settings.checkboxesEnabled ? 2 : 1)">{{ $t('grid.nodata') }}</td>
							</tr>
							<tr class="no-data" ref="preparing" :class="{ 'show': loading2 }" v-show="loading2">
								<td :colspan="filteredColumns.length + (settings.checkboxesEnabled ? 2 : 1)">{{ $t('grid.preparing') }}</td>
							</tr>
							<LazyRow v-for="(item, index) in filteredData" :isRowDisabled="item.isDisabled" :key="index" @cell_mounted="() => cell_mounted = true" @cell_focused_out="() => nav_leavingCell(filteredData[activeRowIndex], activeCol, filteredData)" @row_dbClicked="row_dbClicked" :set="alaki = checkLastItem(index == filteredData.length - 1)" :min-height="itemSize" :unrender="true" :settings="settings" :item="item" :filteredData="filteredData" :gridId="gridId" :index="index"
								:activeRowIndex="activeRowIndex" :filteredColumns="filteredColumns" @data-changed="(obj) => $emit('data-changed', { ...obj, table: filteredData })" @row_checkboxClicked="(obj) => row_checkboxClicked(obj.e, obj.item, obj.index)" @focus_cellClicked="(obj) => focus_cellClicked(obj.index, obj.item, obj.col)" @focus_cellClickedByCtrl="(obj) => focus_cellClickedByCtrl(obj)" />
							<tr style="height:100%"></tr>
						</tbody>
						<tfoot v-if="settings.aggregatesEnabled && settingPermissions.aggregatesPermission" class="grid-foot" ref="foot" style="z-index: 10; position: absolute; bottom: 0; right: 0">
							<tr class="grid-row grid-foot-row">
								<td :data-grid-id="gridId" class="grid-cell indicator frozen fixed" data-id="rowIndicator" style="order: 1" data-distance="0">
									<div class="grid-cell-content"></div>
								</td>
								<td :data-grid-id="gridId" v-if="settings.checkboxesEnabled" class="grid-cell checkbox frozen fixed" data-id="rowCheckbox" @click="row_headerCheckboxClicked" style="order: 2" data-distance="0">
									<div class="grid-cell-content" :style="'color: ' + headerCheckboxValue.color + ';'">
										<icon :icon="headerCheckboxValue.icon" />
									</div>
								</td>
								<td v-for="col of filteredColumns" :key="col.id" :data-grid-id="gridId" :data-id="col.id" :class="{
									'grid-cell': true,
									frozen: col.pinned,
									fixed: !col.draggable,
									'reverse-dir': col.reverseDir,
									'col-active': col.isActive,
								}" :style="'order: ' +
									col.order +
									';' +
									(!col.visibility ? 'display: none' : 'display: table-cell')
									" :data-distance="col.$___distance > -1 ? col.$___distance : null
										">
									<div class="grid-cell-content" :style="[
										col.width === 'auto'
											? {
												'white-space': 'pre',
												'min-width': '100%'
											}
											: {
												'min-width': '100%',
												width: col.width
											},
									]">
										<div class="grid-cell-content-view">
											<Aggregates @aggregate-selected="aggregateSelected" ref="aggregate" :column="col" :filteredData="filteredData[0]" />
										</div>
									</div>
								</td>
							</tr>
						</tfoot>
					</table>
				</div>
			</div>
			<div v-if="toolbarEnabled" class="grid-toolbar" style="z-index: 11; position: relative">
				<div v-if="settings.searchable" v-show="filterBoxVisible" class="filter-panel-holder" ref="tableFilter" tabscope>
					<div class="collection">
						<nk-filter :scheme="settings.filterScheme" v-model="filterGroups" :addGroupButtonVisible="false" ref="filterControl"></nk-filter>
					</div>
					<div class="buttons">
						<button type="button" class="btn btn-primary" @click.stop="filter_closeFilterPanel()">
							<icon icon="filter" />
							{{ $t("table.filter.apply") }}
						</button>
						<button type="button" class="btn btn-outline-purple" @click.stop="$refs.filterControl.addGroup()">
							<icon icon="plus" />
						</button>
					</div>
				</div>
				<div class="toolbar-part pager" v-if="pager.enabled">
					<ul>
						<li v-for="item of pager.numbers" :key="item.value" :class="{
							'pager-item': true,
							'pager-item-active': item.value === pager.pageIndex + 1,
						}">
							<a class="pager-link" href="#" @click.stop="(e) => pager_itemClicked(item, e)">{{ item.text }}</a>
						</li>
					</ul>
				</div>
				<div class="right-part">
					<div v-if="itemsInClipboard.length > 0" class="toolbar-part clipboard">
						<div class="btn-group dropup ltr h-100">
							<button class="tool-button dropdown-toggle h-100 rtl" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								<icon icon="clipboard" class="inline" />
								{{ $t("table.filter.clipboard") }} <span class="badge">{{ itemsInClipboard.length }}</span>
							</button>
							<div class="dropdown-menu dropdown-menu-left rtl text-right">
								<h6 class="dropdown-header">
									{{
										$t("table.filter.clipboard.count", {
											count: itemsInClipboard.length,
										})
									}}
								</h6>
								<div class="dropdown-divider"></div>
								<nk-button class="dropdown-item" :options="{ icon: 'copy', title: $t('table.filter.copy') }" @click="() => clipboard.copyToClipboard(false)"></nk-button>
								<nk-button class="dropdown-item text-purple" :options="{
									icon: 'copy',
									title: $t('table.filter.copy-append'),
								}" @click="() => clipboard.copyToClipboard(true)"></nk-button>
								<div class="dropdown-divider"></div>
								<nk-button class="dropdown-item text-primary" :options="{
									icon: 'check-square',
									title: $t('table.filter.select-in-table'),
								}" @click="clipboard.selectInTable"></nk-button>
								<nk-button class="dropdown-item" :options="{
									icon: 'clipboard',
									title: $t('table.filter.replace'),
								}" @click="clipboard.replaceInTable"></nk-button>
								<nk-button class="dropdown-item" :options="{
									icon: 'paste',
									title: $t('table.filter.paste'),
									shortcut: { keyCode: 86, ctrlKey: true },
								}" @click="clipboard.pasteFromClipboard"></nk-button>
								<div class="dropdown-divider"></div>
								<nk-button class="dropdown-item text-danger" :options="{ icon: 'trash', title: $t('table.filter.cleanup') }" @click="clipboard.clearTableClipboard"></nk-button>
							</div>
						</div>
					</div>
					<div v-if="itemsInClipboard.length == 0" class="toolbar-part clipboard">
						<nk-button class="tool-button" :options="{
							icon: 'copy',
							title: $t('table.filter.copy'),
							hideTitle: true,
						}" @click="() => clipboard.copyToClipboard(false)"></nk-button>
					</div>
					<div v-if="false" class="toolbar-part filter" ref="filterToggler">
						<button class="tool-button" @click.stop="filter_switchFilterPanel()">
							<icon icon="filter" />
							{{ $t("table.filter.filter") }}
							<icon v-if="this.flattedFilteredItems.length" icon="exclamation-circle" class="text-danger" />
							<icon :icon="['fas', 'fa-caret-up']" />
						</button>
					</div>
					<div v-if="stateEnabled" class="toolbar-part templates" ref="templatesCol">
						<button class="tool-button" @click.stop="templates_buttonClicked">
							<icon icon="cog" />
						</button>
					</div>
				</div>
			</div>
			<resize-observer @notify="onGridResized" />
			<div v-if="loading && false" class="grid-loading">
				<span>{{ $t("grid.loading") }}</span>
			</div>
		</div>
		<div v-if="fullScreenStatus" class="grid-dim"></div>
	</div>
</template>
<script>
	import _ from 'lodash'
	import $ from 'jquery'
	import { mapGetters, mapActions } from 'vuex'
	import { isEmpty, Validator } from '~/statics/validators.js'
	import AppStateList from './app-state-list'
	import $sc from '~/plugins/shortcut.collection.js'
	import emptyId from '~/statics/empty-id'
	import interact from 'interactjs'
	import { i18nInstance } from '~/plugins/localization'

	import Label from '~/components/general/nikan-label.vue'
	import dialog from '~/plugins/nikan-dialog-plugin'
	import textVisualizer from '@nikan/text-visualizer'

	import { ResizeObserver } from 'vue3-resize'
	import FilterRow from './filter-row'
	import GridExporter from './grid-exporter.vue'
	import ColumnsVisibility from './columns-visibility'
	import GridSettings from './grid-settings'
	import GridSelectMenu from './grid-select-menu'
	import Aggregates from './aggregates'

	import * as g from './grid.utils'
	import InputButton from '../general/input-button.vue'
	import Button from '../general/button.vue'

	import LazyRow from "./lazy-row.vue"
	import Nk_anime from '~/plugins/anime'
	import { generateUUID } from '@/plugins/helper'


	let GRID_UUID = 100
	let GRID_FULL_SCREEN = false

	const SYSFIELDS_PREFIX = '$___'
	const SYSFIELDS_DROPZONE = SYSFIELDS_PREFIX + 'dropzone'
	const SYSFIELDS_DRAGGABLE = SYSFIELDS_PREFIX + 'draggable'
	const SYSFIELDS_RESIZABLE = SYSFIELDS_PREFIX + 'resizable'
	const SYSFIELDS_VALID = SYSFIELDS_PREFIX + 'valid'
	const SYSFIELDS_INVALIDCELLS = SYSFIELDS_PREFIX + 'invalidCells'
	const SYSFIELDS_DIRTYCELLS = SYSFIELDS_PREFIX + 'dirtyCells'
	const SYSFIELDS_ANGELS = SYSFIELDS_PREFIX + 'angels'
	const SYSFIELDS_LOCKED = SYSFIELDS_PREFIX + 'locked'
	const SYSFIELDS_CHECKED = SYSFIELDS_PREFIX + 'checked'
	const SYSFIELDS_SIZE = SYSFIELDS_PREFIX + 'size'
	const SYSFIELDS_INDEX = SYSFIELDS_PREFIX + 'index'
	const SYSFIELDS_DISTANCE = SYSFIELDS_PREFIX + 'distance'
	const SYSFIELDS_ROWNUMBER = 'rowNumber'
	const SYSFIELDS_ROWSTATE = 'rowState'
	const SYSFIELDS_DISPLAYORDER = 'displayOrder'
	const SYSFIELDS_PAGE = 'page'

	const ROW_NEW = 'new'
	const ROW_CHANGED = 'changed'
	const ROW_UNCHANGED = 'unchanged'
	const ROW_DELETED = 'deleted'

	const DIRECT_ROW_SELECTOR =
		'> .grid > .grid-mainbar > .scroller > table > tbody > '

	const Checkbox = {
		Empty: { icon: 'square', color: '#cccccc' },
		Checked: { icon: 'check-square', color: 'green' },
		Intermediate: { icon: 'minus-square', color: '#000000' },
	}

	export default {
		components: {
			// RecycleScroller,
			ResizeObserver,
			FilterRow,
			GridExporter,
			ColumnsVisibility,
			GridSettings,
			GridSelectMenu,
			Aggregates,
			'nk-btn': Button,
			'input-button': InputButton,
			LazyRow
		},
		props: {
			data: {},
			modelValue: {},
			options: {},
			tabindex: { default: 0 },
		},
		emits: ['activeIndex', 'data-changed', 'update:modelValue', 'row_dbClicked'],
		data() {
			return {
				cell_mounted: false,
				fullScreenStatus: false,
				lastRowIndexClick: null,
				timeoutClickId: null,
				loading: true,
				loading2: false,
				// Settings
				settings: {
					addNewRowOnInit: true,
					emitOnDbClick: true,
					stateUID: '',
					row_ID: 'id',
					itemSize: 30, // number in px
					dataSource: null,
					editable: false,
					activeRowDisabled: false,
					alwaysEmit: false,
					multiselection: false,
					colIndicatorBarEnabled: false,
					checkboxesEnabled: false,
					searchBarEnabled: true,
					aggregatesEnabled: false,
					searchable: true,
					displayOrderEnabled: true,
					sortable: true,
					computedButtons: [],
					exportHandler: null,
					defaultSortByCols: [
						{
							name: 'displayOrder',
							sortState: 'asc',
							type: 'number',
						},
						// {
						// 	name: 'rowNumber',
						// 	sortState: 'asc',
						// 	type: 'number',
						// },
					],
					ltr: false,
					paging: {
						enabled: false,
						pageSize: 1000,
						pageIndex: -1,
						totalPages: 1,
						preparePageRequest: null,

						_loading: false,
					},
					prepareNewRow: null,
					prepareDeleteRow: null,
					prepareLockedRow: null,
					prepareDataSourceModel: null,
					columnsVisibilityEnabled: false,
					columns: [],
					aggregatesDefault: false,
					gridSettingsEnabled: true,
					cellStyleRule: null,
				},

				// UI
				rowWidth: 0,
				horizontalBoundery: 0,
				stopUserSelectOnTable: false,
				activeRowIndex: null,
				activeCol: null,
				searchedCols: [],
				filterBoxVisible: false,
				filterGroups: [],
				disableAutoMoveFocusFirstCol: false,
				temporaryReadonly: false,
				errorCellNames: [],
				errorCellMessages: [],
				templatesIsOpen: false,
				currentTemplate: null,
				cleanTable: true,
				tableIsFocusOut: true,
				clipboardMenuOpened: false,
				headCheckboxIcon: Checkbox.Empty,

				// Value
				preservedValue: null,
				notFoundValueItems: [],
				clonedData: null,
				originalData: null,
				originalBindData: null,
				newRowIdSequence: 0,
				oldDataLength: 0,

				gridId: -1,
				scrollBarWidth: 0,

				clipboard: null,
				operation: '',
			}
		},
		computed: {
			...mapGetters({
				getActiveState: 'appStates/getActiveByKey',
				allItemsInClipboard: 'clipboard/getItemsInTable',
				menuStatus: 'menuStatus'
			}),
			settingPermissions() {
				const hasAggregatesPermission = this.$nikan.checkPermission('General_Grid_Aggregate')
				const hasExportPermission = this.$nikan.checkPermission('General_Grid_Export')

				return { aggregatesPermission: hasAggregatesPermission, exportPermission: hasExportPermission }
			},
			settingButtons() {
				return [
					{
						id: this.idGenerator(5),
						displayOrder: 8,
						handler: () => this.fullScreen(),
						class: "no-outline",
						type: 'nk-btn',
						options: {
							visible: true,
							isPrimary: false,
							icon: this.fullScreenStatus ? 'fa-solid fa-compress' : 'fa-solid fa-expand',
							tooltipEnabled: true,
							hideTitle: true,
							title: this.fullScreenStatus ? i18nInstance.global.t('table.buttons.minimize') : i18nInstance.global.t('table.buttons.maximize'),
							shortcut: $sc.find('full-screen', 'table'),
							element: () => this.$el,
						}
					},
				]
			},
			noDataClass() {
				$(this.$refs.nodata).removeClass('show')
				this.defer(() => {
					if (this.filteredData.length === 0 && !this.loading2)
						$(this.$refs.nodata).addClass('show')
				}, 1)
				return {
					'': this.filteredData.length === 0,
				}
			},
			headerCategories() {
				let categories = []

				for (let index = 0; index < this.filteredColumns.length; index++) {
					const column = this.filteredColumns[index]
					if (column.visibility) {
						if (column.headerCategory) {
							let cat = categories.find(
								(category) =>
									category.col.headerCategory === column.headerCategory
							)
							if (cat) {
								cat.colspan++
							} else {
								categories.push({
									col: column,
									colspan: 1,
								})
							}
						} else {
							categories.push({
								col: column,
								colspan: 1,
							})
						}
					}
				}
				return categories
			},
			pb() {
				if (this.aggregatesLength > 0 || this.settings.aggregatesDefault || this.settings.aggregatesEnabled) {
					let aggRows = Array.isArray(this.localValue) && this.localValue.length > 1 ? 2 : 1
					return `${aggRows * this.settings.itemSize}px`
				}
				return '0'
			},
			filteredColumns() {
				return this.settings.columns.filter(column => typeof column.visible === 'function' ? column.visible(column) !== false : column.visible !== false)
			},
			filteredData() {
				if (!this.clonedData) {
					return []
				}
				var filtered = this.clonedData
				if (this.settings.searchable === true && this.searchedCols.length) {
					for (var i = 0; i < this.searchedCols.length; i++) {
						var col = this.searchedCols[i]
						filtered = this.search_col(filtered, col)
					}
				}

				if (this.settings.sortable === true) {
					let mergedSortableCols = this.sort_sortingCols(true)

					if (mergedSortableCols.length) {
						let sorter = this.sort_multiple(mergedSortableCols)
						filtered.sort(sorter)
						this.originalData.sort(sorter)
						this.clonedData.sort(sorter)
					}
				}
				return filtered
			},
			isEditable() {
				if (this.temporaryReadonly === true) {
					return false
				}

				if (this.settings.editable === true) {
					return true
				} else {
					return false
				}
			},
			tableWidth() {
				if (this.$el == null) return 0

				return parseInt(getComputedStyle(this.$el).width, 10)
			},

			flattedFilteredItems() {
				let items = this.filterGroups.reduce((items, group) => {
					items.push(...group.items)
					return items
				}, [])

				items = items.filter((x) => !isEmpty(x.value))
				items = items.reduce((items, item) => {
					if (!items.filter((x) => x.key === item.key).length) {
						items.push(item)
					}

					return items
				}, [])

				return items
			},

			aggregatesLength() {
				return this.filteredColumns
					.map((x) => {
						return x.aggregates.filter((x) => x.visible).length
					})
					.reduce((max, current) => {
						if (max < current) {
							return current
						} else {
							return max
						}
					}, 0)
			},

			headerCategoryLength() {
				let len = 0
				this.filteredColumns.find((col) => {
					if (col.headerCategory) {
						len++
					}
				})
				return len
			},

			pager() {
				let totalPages = this.settings.paging.totalPages
				let pageIndex = this.settings.paging.pageIndex

				let obj = {
					enabled: false,
				}

				if (!this.settings.paging.enabled) {
					return obj
				}

				let numbers = []
				let push = (text, value) =>
					numbers.push({ text: text.toString().toPersianDigits(), value })

				if (totalPages <= 7) {
					for (let i = 0; i < totalPages; i++) {
						push(i + 1, i + 1)
					}
				} else {
					let startIndex = pageIndex - 1
					let endIndex = pageIndex + 2

					startIndex = startIndex < 0 ? 0 : startIndex
					endIndex = endIndex >= totalPages ? totalPages - 1 : endIndex

					if (pageIndex > 0) {
						push(this.$t('previous'), pageIndex)
					}

					if (startIndex > 2) {
						push(1, 1)

						if (startIndex > 5) {
							push('...', parseInt(startIndex / 2))
						} else {
							push('...', 2)
						}
					} else if (startIndex > 0) {
						for (let i = 0; i < startIndex; i++) {
							push(i + 1, i + 1)
						}
					}

					for (let i = startIndex; i < endIndex; i++) {
						push(i + 1, i + 1)
					}

					if (endIndex < totalPages - 2) {
						let diff = totalPages - endIndex
						if (diff > 5) {
							push('...', endIndex + parseInt(diff / 2))
						} else {
							push('...', totalPages - 2)
						}

						for (let i = totalPages - 1; i < totalPages; i++) {
							push(i + 1, i + 1)
						}
					} else if (endIndex < totalPages) {
						for (let i = endIndex; i < totalPages; i++) {
							push(i + 1, i + 1)
						}
					}

					if (pageIndex < totalPages - 1) {
						push(this.$t('next'), pageIndex + 2)
					}
				}

				return _.extend(obj, {
					enabled: this.settings.paging.enabled,
					pageIndex,
					numbers,
				})
			},
			itemsInClipboard() {
				return this.allItemsInClipboard(this.settings.stateUID) || []
			},
			localValue() {
				return this.filteredData.filter((x) => x[SYSFIELDS_CHECKED] === true)
			},
			headerCheckboxValue() {
				if (this.filteredData.length === 0 || this.localValue.length === 0) {
					return Checkbox.Empty
				} else if (this.localValue.length === this.filteredData.length) {
					return Checkbox.Checked
				} else {
					return Checkbox.Intermediate
				}
			},

			toolbarEnabled() {
				return this.settings.paging.enabled // || this.stateEnabled // && other items in toolbar;
			},
			stateEnabled() {
				return this.settings.stateUID != null && this.settings.stateUID !== ''
			},
			templatesOptions() {
				return {
					header: true,
					component: AppStateList,
					data: this.currentTemplate,
					options: {
						key: this.settings.stateUID,
					},
				}
			},
			maxHeight() {
				return this.settings.maxHeight || 0
			},
			itemSize() {
				if (!this.settings.itemSize || this.settings.itemSize < 30) {
					return 30
				}

				if (_.isFunction(this.settings.itemSize)) {
					return this.settings.itemSize()
				} else {
					return this.settings.itemSize
				}
			},
			col_hasError(rowIndex, colId) {
				return (
					this.errorCellNames.indexOf(this.col_getCellUID(rowIndex, colId)) > -1
				)
			},
			id() {
				return 'nkGrid_' + this.settings.stateUID
			}
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val, oldVal) {
					this.init_prepareSettings(val)
					this.$nextTick(() => {
						this.init(true)
					})
				},
			},
			'options.buttons': {
				immediate: true,
				deep: true,
				handler(val, oldVal) {
					this.computeButtons(val)
				},
			},
			data: {
				immediate: true,
				deep: true,
				handler(val) {
					this.defer(() => {

						// after updating data such as deletion and etc... clear modelValue from deleted row
						// commented whole delete thing causes data blurs to crash the whole table functionality
						// if (val && val.findIndex(x => x.id !== this.modelValue?.id))
						// this.$emit('update:modelValue', null)

						this.loading2 = val && val.length > 0 ? true : false
						this.init_cloneData(val)

						if (val && val.length && this.oldDataLength > val.length)
							this.focus_scrollTop()

						this.oldDataLength = val && val.length ? val.length : 0

					}, 1)
				},
			},
			activeRowIndex: {
				handler(val) {
					this.$emit('activeIndex', val)
				}
			},
			cell_mounted: {
				handler(val) {
					setTimeout(() => {
						this.cell_mounted = false
					}, 100)
				}
			},
		},
		beforeCreate() {
			this.gridId = GRID_UUID.toString()
			GRID_UUID += 1
		},
		created() {
			this.gridId = GRID_UUID.toString()

			this.clipboard = g.clipboard.config(this)

			this.table_OnFocusout = _.debounce(this.table_OnFocusout, 100)
			this.onGridResized = _.throttle(this.onGridResized, 300)
			this.pager_move = _.debounce(this.pager_move, 500)
			this.pager_next = _.debounce(this.pager_next, 200)
			this.pager_prev = _.debounce(this.pager_prev, 200)
			this.focus_activateFirstVisibleRow = _.debounce(
				this.focus_activateFirstVisibleRow,
				200
			)

			this.table_OnFocusout = this.table_OnFocusout.bind(this)
			this.templates_bodyClicked = this.templates_bodyClicked.bind(this)

			this.activeCol = _.head(this.filteredColumns)

			var val = this.modelValue
			if (val != null) {
				val = Array.isArray(val) ? val : [val]

				for (let i = 0; i < val.length; i++) {
					this.value_tryAdd(val[i], i === 0)
				}
			}

			this.defer(() => {
				// this.init_cloneData(this.data)
			}, 1)

			g.clipboard.store.configTable({
				stateUID: this.settings.stateUID,
				row_IDKey: this.row_IDKey(),
			})
		},

		mounted() {
			this.enableAggregateRowByLength()
			this.loadGridStates()
			this.scrollBarWidth = g.getScrollBarWidth()

			if (this.pager.enabled) {
				this.pager_next()
			} else if (this.settings.dataSource != null) {
				this.init_loadDataSource()
			}

			this.focus_activateRowByValue()
			this.table_FocusCheck('on')
			this.templates_init()
			this.computeButtons()
		},
		methods: {
			...mapActions('appStates', {
				modifyStates: 'modify',
				syncStates: 'sync',
				refreshStates: 'refresh',
			}),
			...mapActions({
				menu_show: 'hide_show',
			}),
			rowMounted() {
				this.cellMounted = true
				this.defer(() => this.cellMounted = false, 100)
			},
			enableAggregateRowByLength() {
				if (this.aggregatesLength > 0)
					this.settings.aggregatesEnabled = true
			},
			row_dbClicked(index, e) {
				if (!this.settings.editable && this.settings.emitOnDbClick && index !== null && index > -1) {
					// this.focus_cellDblClicked(rowIndex, row, col, focusSearchRow)
					var clone = _.cloneDeep(this.filteredData[index])
					var cleanedRow = this.init_getPureRecords([clone])[0]
					if (!this.menuStatus) this.fullScreen()
					this.$emit('row_dbClicked', cleanedRow, e)
				}
			},
			computeButtons(buttons = this.settings.buttons) {
				let buttonsObj = _.merge(this.getDefaultButtons(), buttons)
				let buttonsArray = Object.values(buttonsObj) || []

				buttonsArray.map((x => {
					x.id ? x.id : x.id = this.idGenerator(5)
					x.options.visible ? x.options.visible : true
					x.options.disabled ? x.options.disabled : false
					return x
				}))

				buttonsArray = buttonsArray.filter(x => x.options.visible !== false)
				this.settings.computedButtons = buttonsArray.sort((a, b) => (a.displayOrder > b.displayOrder) ? 1 : -1)
			},
			getDefaultButtons() {
				return {
					addBtn: {
						id: this.idGenerator(5),
						displayOrder: 1,
						handler: this.row_addNewRow,
						class: "no-outline",
						type: 'nk-btn',
						options: {
							visible: false,
							isPrimary: false,
							icon: 'plus',
							tooltipEnabled: true,
							hideTitle: true,
							title: i18nInstance.global.t('table.buttons.add'),
							shortcut: $sc.find('insert-new-row', 'table'),
							element: () => this.$el,
							hideShortcut: true,
						}
					},
					duplicateBtn: {
						id: this.idGenerator(5),
						displayOrder: 2,
						handler: this.duplicateRows,
						class: "mr-2 no-outline",
						type: 'nk-btn',
						options: {
							visible: false,
							icon: 'copy',
							isDanger: false,
							tooltipEnabled: true,
							hideTitle: true,
							title: i18nInstance.global.t('table.buttons.copy'),
							shortcut: $sc.find('copy', 'table'),
							element: () => this.$el,
							hideShortcut: true,
						}
					},
					upBtn: {
						id: this.idGenerator(5),
						displayOrder: 3,
						handler: this.up,
						class: "mr-2 no-outline",
						type: 'nk-btn',
						options: {
							visible: false,
							icon: 'arrow-up',
							isDanger: false,
							tooltipEnabled: true,
							hideTitle: true,
							title: i18nInstance.global.t('table.buttons.up'),
							shortcut: $sc.find('move-up', 'table'),
							element: () => this.$el,
							hideShortcut: true,
						}
					},
					downBtn: {
						id: this.idGenerator(5),
						displayOrder: 4,
						handler: this.down,
						class: "mr-2 no-outline",
						type: 'nk-btn',
						options: {
							visible: false,
							icon: 'arrow-down',
							isDanger: false,
							tooltipEnabled: true,
							hideTitle: true,
							title: i18nInstance.global.t('table.buttons.down'),
							shortcut: $sc.find('move-down', 'table'),
							element: () => this.$el,
							hideShortcut: true,
						}
					},
					transferBtn: {
						id: this.idGenerator(5),
						displayOrder: 5,
						handler: this.transfer,
						class: "mr-2 no-outline",
						type: 'input-button',
						options: {
							visible: false,
							icon: 'fal fa-arrows-v',
							isDanger: false,
							tooltipEnabled: true,
							hideTitle: true,
							title: i18nInstance.global.t('table.buttons.transfer'),
						}
					},
					deleteBtn: {
						id: this.idGenerator(5),
						displayOrder: 6,
						handler: this.row_deleteRow,
						class: "mr-2 no-outline",
						element: () => this.$el,
						type: 'nk-btn',
						options: {
							visible: false,
							icon: 'trash',
							isOutlineDanger: true,
							tooltipEnabled: true,
							hideTitle: true,
							title: i18nInstance.global.t('table.buttons.delete'),
							shortcut: $sc.find('delete-row', 'table'),
							element: () => this.$el,
							hideShortcut: true,
						}
					},
					saveBtn: {
						id: this.idGenerator(5),
						displayOrder: 7,
						handler: () => this.resolve('save'),
						class: "mr-2 no-outline",
						type: 'nk-btn',
						options: {
							visible: false,
							isPrimary: true,
							icon: 'save',
							tooltipEnabled: true,
							hideTitle: true,
							title: i18nInstance.global.t('table.buttons.save'),
						}
					},
				}
			},
			duplicateRows(button, e, callback) {
				var cloned = _.cloneDeep(this.localValue)
				let insertIndex = this.filteredData.length

				if (!cloned.length)
					return false

				for (let index = 0; index < cloned.length; index++) {
					cloned[index] = this.row_getClonedObjectAsNew(cloned[index], insertIndex, true)
					if (_.isFunction(callback))
						callback(cloned[index])

					this.row_tryAddRecordAt(insertIndex, cloned[index], true)

					insertIndex++
				}

				var item = this.filteredData[this.activeRowIndex]
				this.value_add(item, true)
			},
			async up(button, e) {

				if (this.activeRowIndex <= 0) return

				var data = _.cloneDeep(this.clonedData)
				if (!data || data.length == 0) return

				var source = _.cloneDeep(data[this.activeRowIndex - 1])
				var target = _.cloneDeep(data[this.activeRowIndex])

				data[this.activeRowIndex] = source
				data[this.activeRowIndex].displayOrder = target.displayOrder
				data[this.activeRowIndex].rowNumber = target.rowNumber

				data[this.activeRowIndex - 1] = target
				data[this.activeRowIndex - 1].displayOrder = source.displayOrder
				data[this.activeRowIndex - 1].rowNumber = source.rowNumber


				this.clonedData = data
				this.activeRowIndex = this.activeRowIndex - 1

			},
			/**
			 * handle fullscreen button clicked
			 */
			fullScreen() {
				this.fullScreenStatus = !this.fullScreenStatus
				if (this.gridId == 101) GRID_FULL_SCREEN = this.fullScreenStatus
				const anime = new Nk_anime(`.grid_${this.gridId}`, {
					translateX: 70,
					translateY: -80,
					easing: 'linear',
					duration: 500,
				})
				const before_anime = new Nk_anime(`.grid_${this.gridId}`, {
					translateX: 0,
					translateY: 0,
					easing: 'linear',
					duration: 500,
				})
				this.fullScreenStatus ? anime.play() : before_anime.play()
				if (this.fullScreenStatus) this.menu_show(false)
				else {
					!GRID_FULL_SCREEN && this.menu_show(true)
				}
			},
			down(button, e) {
				let selectDetailRow
				if (this.settings.multiselection === true) {
					selectDetailRow = this.localValue
				} else {
					selectDetailRow = _.head(this.localValue)
				}

				if (!selectDetailRow) return

				var data = _.cloneDeep(this.clonedData)
				if (!data || data.length == 0 || this.activeRowIndex + 1 >= data.length)
					return

				var source = _.cloneDeep(data[this.activeRowIndex + 1])
				var target = _.cloneDeep(data[this.activeRowIndex])

				data[this.activeRowIndex] = source
				data[this.activeRowIndex].displayOrder = target.displayOrder
				data[this.activeRowIndex].rowNumber = target.displayOrder

				data[this.activeRowIndex + 1] = target
				data[this.activeRowIndex + 1].displayOrder = source.displayOrder
				data[this.activeRowIndex + 1].rowNumber = source.rowNumber

				this.clonedData = data
				this.activeRowIndex = this.activeRowIndex + 1
			},
			transfer(val, e) {

				if (e) e.preventDefault()
				let activeRowIndex = this.activeRowIndex
				if (!activeRowIndex < 0 || !val || isNaN(val)) return

				val = val - 1
				var data = _.cloneDeep(this.clonedData)
				if (!data) return


				if (data.length - 1 < val) val = data.length - 1
				else if (val < 1) val = 0

				if (activeRowIndex == val) return

				if (val > activeRowIndex) {
					var temp = data[activeRowIndex]
					temp.displayOrder = data[val].displayOrder
					for (var i = activeRowIndex; i < val; i++) {
						var displayOrder = data[i].displayOrder
						data[i] = data[i + 1]
						data[i].displayOrder = displayOrder
					}
					data[val] = temp
				} else {
					var temp = data[activeRowIndex]
					temp.displayOrder = data[val].displayOrder
					for (var i = activeRowIndex; i > val; i--) {
						var displayOrder = data[i].displayOrder
						data[i] = data[i - 1]
						data[i].displayOrder = data[i].displayOrder
					}
					data[val] = temp
				}
				this.clonedData = data
			},
			generateEmptyRow(item) {
				item = item || {}
				let obj = {}
				obj.account = item.account || null
				obj.centers = item.centers || []
				obj.currencyValues = item.currencyValues || [
					{
						credit: 0,
						debit: 0,
						debitCurrency: 0,
						creditCurrency: 0,
						currency: {},
					},
				]
				obj.isReadOnly = false
				obj.count = ''
				obj.date = null
				obj.description = ''
				obj.descriptionAlternative = ''
				obj.trackNumber = ''
				return obj
			},
			checkLastItem(lastItem) {
				if (lastItem) {
					this.loading2 = false
					this.init_footColsWidth()
				}
			},
			discardChanges() {
				this.clonedData = _.cloneDeep(this.originalBindData)
			},
			commitChanges() {
				var _vm = this

				return new Promise((resolve, reject) => {
					var activeRow = _vm.filteredData[_vm.activeRowIndex]
					if (activeRow && !_vm.row_isEmpty(activeRow)) {
						let ableToLeaveActiveCell = _vm.nav_leaveCell(
							_vm.activeRowIndex,
							_vm.activeCol
						)
						if (!ableToLeaveActiveCell) {
							reject(new Error('unable to leave the cell'))
							return
						}
						_vm.nav_leavingCell(activeRow, _vm.activeCol, this.filteredData)
						_vm.validate_row(_vm.activeRowIndex)
						if (_vm.errorCellNames.length > 0) {
							var item = {
								row: _vm.clonedData[_vm.activeRowIndex],
								rowNumber: _vm.activeRowIndex + 1,
								errorCellNames: _vm.errorCellNames,
								errorCellMessages: _vm.errorCellMessages,
							}

							reject([item])
							return
						}
					}

					let data = _vm.init_getPureRecords(_vm.clonedData)
					resolve(data)
				})
			},
			getTableData() {
				// const activeRow = this.filteredData[this.activeRowIndex]
				// if (activeRow && !this.row_isEmpty(activeRow)) {
				//  const invalidActiveRow = {
				//    row: activeRow,
				//    rowNumber: this.activeRowIndex + 1
				//  }

				//  const ableToLeaveActiveCell = this.nav_leaveCell(
				//    this.activeRowIndex,
				//    this.activeCol
				//  )
				//  if (!ableToLeaveActiveCell) {
				//    return {
				//      success: false,
				//      error: 'cell-leave-prevented',
				//      data: [],
				//      invalidRows: [invalidActiveRow]
				//    }
				//  }

				//  this.nav_leavingCell(activeRow, this.activeCol)

				//  this.validate_row(this.activeRowIndex)
				//  if (this.errorCellNames.length > 0) {
				//    return {
				//      success: false,
				//      error: 'invalid-rows',
				//      data: [],
				//      invalidRows: [invalidActiveRow]
				//    }
				//  }
				// }

				const data = this.init_getPureRecords(this.clonedData)
				return {
					success: true,
					data,
				}
			},
			read() {
				if (this.settings.dataSource == null) {
					throw new Error('There is no data-source assigned to this grid.')
				}

				return this.init_loadDataSource()
			},

			onGridResized(size) {
				this.filteredColumns.forEach((col) => {
					col.width = col.oldWidth || col.width
				})

				this.init()
			},
			init(delayed) {
				let act = () => {
					this.init_calculateRowWidth()
					this.init_prepareColumnsWidth()
					this.init_prepareFrozenCells()
					this.init_enableDropZones()
					this.init_enableDraggables()
					this.init_enableResizable()
					this.init_footColsWidth()
				}

				if (delayed) {
					setTimeout(act, 100)
				} else {
					act()
				}
			},
			init_prepareFrozenCells() {
				if (!this.$refs.head) {
					return
				}

				let positionStart = this.getDefaultColumnsWidth()

				this.filteredColumns.forEach((col) => {
					if (col.pinned) {
						col[SYSFIELDS_DISTANCE] = positionStart
					} else {
						col[SYSFIELDS_DISTANCE] = -1
						let cell = this.$refs.head.selectAll(
							'> .grid-head-row > .grid-cell[data-id="' + col.id + '"]'
						)[0]
						let cellStyle = getComputedStyle(cell)
						positionStart += parseInt(cellStyle.width, 10)
					}
				})
			},
			init_prepareColumnsWidth() {

				const autoCols = this.filteredColumns.filter(
					(col) => col.clientOffset.auto === true
				)
				let autoColWidth = 0

				if (autoCols.length > 0) {
					// const fixedwidthSum = this.filteredColumns
					//  .filter((col) => col.clientOffset.auto !== true)
					//  .map((col) => parseFloat(col.width))
					//  .reduce((sum, current) => {
					//    sum += current
					//    return sum
					//  }, defaultColsWidth)
					// if (this.horizontalBoundery > fixedwidthSum) {
					//  const diff = this.horizontalBoundery - fixedwidthSum
					//  autoColWidth = (diff / autoCols.length) + 'px'
					// }
					// else {
					//  autoColWidth = 'auto'
					// }
					autoColWidth = 'auto'
				}

				this.filteredColumns.forEach((col) => {
					col.width = col.clientOffset.auto === true ? autoColWidth : col.width
				})
			},
			init_footColsWidth() {
				if (!this.$refs.foot) return

				this.$refs.foot.querySelectorAll(`[data-id]`).forEach((currentCell) => {
					var cell = $(
						`[data-id="${currentCell.getAttribute('data-id')}"]`,
						$(this.$refs.head)
					)[0]
					if (cell) {
						let cs = getComputedStyle(cell)
						var paddingX =
							parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight)
						var borderX =
							parseFloat(cs.borderLeftWidth) + parseFloat(cs.borderRightWidth)
						let width = cell.getBoundingClientRect().width - paddingX - borderX
						$(currentCell).css('width', width)
						$(' > div', $(currentCell)).css('width', width)
					}
				})
			},

			getAutoWidthColumns() {
				return this.filteredColumns.filter(
					(col) => col.clientOffset.auto === true
				)
			},
			getDefaultColumnsCount(checkboxesEnabled) {
				return checkboxesEnabled ? 2 : 1
			},
			getDefaultColumnsWidth(defaultColumnsCount) {
				if (!this.$refs.head) return
				return this.col_sortCellsByOrder(
					this.$refs.head.selectAll('> .grid-head-row > .grid-cell')
				)
					.filter((el, index) => index < defaultColumnsCount)
					.map((cell) => {
						const style = getComputedStyle(cell)
						return {
							cell,
							width: parseFloat(style.width),
							borderLeft: parseFloat(style.getPropertyValue('border-left-width')),
							borderRight: parseFloat(
								style.getPropertyValue('border-right-width')
							),
						}
					})
					.map((item) => {
						return {
							cell: item.cell,
							width: item.width + item.borderLeft + item.borderRight,
						}
					})
					.reduce((sum, item) => {
						sum += item.width
						return sum
					}, 0)
			},

			init_enableDropZones() {
				if (!this.$refs.head) return
				this.$refs.head
					.selectAll('> .grid-head-row > .grid-cell')
					.forEach((headCell) => {
						let dropzone = headCell.querySelector('.dropzone')
						if (dropzone == null) return

						let name = headCell.getAttribute('data-id')
						let col = _.head(this.settings.columns.filter((x) => x.id === name))
						if (col == null) return



						col[SYSFIELDS_DROPZONE] = interact(dropzone).dropzone({
							accept: '.grid-cell',
							// overlap: 0.50,

							ondropactivate: (event) => {
								// add active dropzone feedback
								event.target.classList.add('drop-active')
							},
							ondragenter: (event) => {
								let draggableElement = event.relatedTarget
								let dropzoneElement = event.target

								// feedback the possibility of a drop
								dropzoneElement.classList.add('drop-target')
								draggableElement.classList.add('can-drop')
							},
							ondragleave: (event) => {
								// remove the drop feedback style
								event.target.classList.remove('drop-target')
								event.relatedTarget.classList.remove('can-drop')
							},
							ondrop: (event) => {
								// this.init()
								let draggedCellId = event.relatedTarget.getAttribute('data-id')
								let dropzone = event.target
								let dropCellId =
									dropzone.parentElement.parentElement.getAttribute('data-id')

								let dragIndex = this.filteredColumns.findIndex(
									(x) => x.id === draggedCellId
								)
								let dropIndex = this.filteredColumns.findIndex(
									(x) => x.id === dropCellId
								)

								for (var i = dragIndex; i < dropIndex; i++) {
									let temp = this.filteredColumns[i]
									this.filteredColumns[i] = this.filteredColumns[i + 1]
									this.filteredColumns[i + 1] = temp
								}

								for (var j = dragIndex; j > dropIndex; j--) {
									let temp = this.filteredColumns[j]
									this.filteredColumns[j] = this.filteredColumns[j - 1]
									this.filteredColumns[j - 1] = temp
								}

								for (
									let index = 0;
									index < this.filteredColumns.length;
									index++
								) {
									this.filteredColumns[index].order = index
								}

								setTimeout(() => {
									let cells = this.$refs.head.selectAll(
										'> .grid-head-row > .grid-cell'
									)
									if (cells.length) {
										var positionStart = 0
										for (var i = 0; i < cells.length; i++) {
											if (cells[i].classList.contains('frozen')) {
												cells[i].setAttribute('data-distance', positionStart)
											} else {
												let cellStyle = getComputedStyle(cells[i])
												let cellWidth = parseInt(cellStyle.width, 10)
												positionStart += cellWidth
												cells[i].removeAttribute('data-distance')
											}
										}
									}
								}, 500)
							},
							ondropdeactivate: (event) => {
								// remove active dropzone feedback
								event.target.classList.remove('drop-active')
								event.target.classList.remove('drop-target')
							},
						})
					})
			},
			init_enableDraggables() {
				if (!this.$refs.head || this.headerCategoryLength > 0) return
				this.$refs.head
					.selectAll('> .grid-head-row > .grid-cell:not(.fixed)')
					.forEach((headCell) => {
						let name = headCell.getAttribute('data-id')
						let col = _.head(this.filteredColumns.filter((x) => x.id === name))
						if (col == null) return


						col[SYSFIELDS_DRAGGABLE] = interact(headCell).draggable({
							inertia: true,
							modifiers: [
								interact.modifiers.restrictRect({
									restriction: 'parent',
									endOnly: true,
								}),
							],
							autoScroll: true,
							onstart: (event) => {
								let target = event.target
								target.style.opacity = 0.5
								target.classList.add('moving')

								this.stopUserSelectOnTable = true
							},
							onmove: (event) => {
								let target = event.target
								let x =
									(parseFloat(target.getAttribute('data-x')) || 0) + event.dx
								let y =
									(parseFloat(target.getAttribute('data-y')) || 0) + event.dy

								target.style.webkitTransform = target.style.transform =
									'translate(' + x + 'px, ' + y + 'px)'

								target.setAttribute('data-x', x)
								target.setAttribute('data-y', y)
							},
							onend: (event) => {
								let target = event.target

								target.removeAttribute('data-x')
								target.removeAttribute('data-y')
								target.style.transform = null
								target.style.opacity = 1.0
								target.classList.remove('moving')

								this.stopUserSelectOnTable = false
							},
						})
					})
			},
			init_enableResizable() {
				if (!this.$refs.head) return
				this.$refs.head
					.selectAll('> .grid-head-row > .grid-cell')
					.forEach((headCell) => {
						let sizer = headCell.select('> .grid-cell-sizer')
						if (sizer == null) return

						let name = headCell.getAttribute('data-id')
						let col = _.head(this.settings.columns.filter((x) => x.id === name))

						if (col == null) return


						const restrictSize = {
							min: col.clientOffset.min
								? { width: parseInt(col.clientOffset.min, 10) }
								: { width: 50 },
							max: col.clientOffset.max
								? { width: parseInt(col.clientOffset.max, 10) }
								: { width: isNaN(col.width) ? 500 : Math.floor(col.width) * 3 },
						}

						col[SYSFIELDS_RESIZABLE] = interact(sizer)
							.resizable({
								// resize from all edges and corners
								edges: this.settings.ltr
									? { right: '.sizer-handle' }
									: { left: '.sizer-handle' },

								modifiers: [
									// keep the edges inside the parent
									interact.modifiers.restrictEdges({
										outer: 'parent',
										endOnly: true,
									}),

									// minimum size
									interact.modifiers.restrictSize(restrictSize),
								],

								inertia: false,
							})
							.on('resizestart', (event) => {
								this.stopUserSelectOnTable = true
							})
							.on('resizeend', (event) => {
								this.stopUserSelectOnTable = false

								let target = event.target
								let cell = target.parentElement
								let name = cell.getAttribute('data-id')
								let col = _.head(
									this.settings.columns.filter((x) => x.id === name)
								)

								const oldWidth = parseFloat(col.width)
								col.width = event.rect.width.toString() + 'px'

								this.init_prepareFrozenCells()

								let widthDif = event.rect.width - oldWidth
								this.rowWidth += widthDif
								// this.row_setRowElementWidth(this.rowWidth)

								setTimeout(this.init_syncScrollbars, 100)
							})
							.on('resizemove', (event) => {
								if (isNaN(event.rect.width)) {
									return
								}

								let target = event.target
								let cell = target.parentElement
								let id = cell.getAttribute('data-id')
								let col = _.head(this.filteredColumns.filter((x) => x.id === id))

								col.width = event.rect.width + 'px'

								this.defer(() => {
									this.init_footColsWidth()
								}, 1)

								this.init_prepareFrozenCells()
							})
					})
			},

			init_cloneData(data) {
				this.value_preserve()

				let val = this.pager_getItems(data)
				var valIsEmpty = val == null || !Array.isArray(val) || val.length === 0

				if (!valIsEmpty) {
					val = val.map((item, index) => {
						let newItem = _.merge(
							// defaults
							{
								[this.row_IDKey()]: this.row_NewID(),
								rowState: ROW_UNCHANGED,
								displayOrder: index + 1,
							},

							// the item
							item,

							// requireds
							{
								[SYSFIELDS_ROWNUMBER]: this.row_getRowNumber(index),
								[SYSFIELDS_VALID]: true,
								[SYSFIELDS_INVALIDCELLS]: [],
								[SYSFIELDS_DIRTYCELLS]: [],
								[SYSFIELDS_ANGELS]: [],
								[SYSFIELDS_LOCKED]: null,
								[SYSFIELDS_CHECKED]: false,
								[SYSFIELDS_SIZE]: 30,
								[SYSFIELDS_PAGE]: 1,
								[SYSFIELDS_INDEX]: index,
							}
						)

						if (this.row_ID(newItem) < 0) {
							newItem.rowState = ROW_NEW
						}

						Object.defineProperty(newItem, 'isDeleted', {
							get() {
								return newItem[SYSFIELDS_ROWSTATE] === ROW_DELETED
							},
						})

						Object.defineProperty(newItem, 'isNew', {
							get() {
								return newItem[SYSFIELDS_ROWSTATE] === ROW_NEW
							},
						})

						Object.defineProperty(newItem, 'isSelected', {
							get() {
								return newItem[SYSFIELDS_CHECKED] === true
							},
						})

						if (
							newItem[SYSFIELDS_LOCKED] == null &&
							_.isFunction(this.settings.prepareLockedRow)
						) {
							newItem[SYSFIELDS_LOCKED] = this.settings.prepareLockedRow.call(
								this,
								newItem,
								newItem[SYSFIELDS_INDEX],
								this.filteredData
							)
						} else {
							newItem[SYSFIELDS_LOCKED] = newItem[SYSFIELDS_LOCKED] || false
						}

						Object.defineProperty(newItem, 'isLocked', {
							get() {
								return !!newItem[SYSFIELDS_LOCKED]
							},
						})

						return newItem
					})
					if (this.settings.displayOrderEnabled) {
						val = val.sort((first, second) => {
							let a = first[SYSFIELDS_DISPLAYORDER]
							let b = second[SYSFIELDS_DISPLAYORDER]

							if (a > b) return 1
							if (a === b) return 0
							if (a < b) return -1
						})
					}
				}

				this.originalData = []
				this.originalBindData = []
				this.errorCellNames = []
				this.errorCellMessages = []
				this.activeCol =
					this.filteredColumns.length > 0 ? this.filteredColumns[0] : null

				const applyData = () => {
					this.cleanTable = false
					this.clonedData = val

					if (valIsEmpty) {
						this.activeRowIndex = -1
						this.clonedData = []
						if (this.settings.addNewRowOnInit)
							if (this.row_tryAddEmpty()) {
								this.activeRowIndex = 0
							}
					} else {
						this.activeRowIndex = 0

						this.originalData = _.cloneDeep(this.clonedData)
						this.originalBindData = _.cloneDeep(this.clonedData)
					}

					this.value_loadPreserved()

					this.focus_activeSelectedRow()
					this.col_applyAllAggregates()

					const scrollToCell = () => {
						setTimeout(this.focus_scrollToFirstCell, 10)
						setTimeout(this.init_syncScrollbars, 150)
					}

					if (this.getAutoWidthColumns().length > 0) {
						this.$nextTick(() => {
							scrollToCell()
						})
					} else {
						scrollToCell()
					}
					this.prepareDropdownFilterItems()
				}

				if (this.cleanTable === true) {
					applyData()
				} else {
					// this.clonedData = null
					this.defer(applyData, 10)
				}
				this.init_footColsWidth()
			},
			init_prepareSettings(options) {
				const state = this.getActiveState(options.stateUID)
				const stateTableSettings = _.get(state, 'value.tableSettings') || {}

				let editableChanged = !this.settings.editable !== !options.editable

				this.settings = _.merge(this.settings, options, stateTableSettings)

				this.settings.searchable = this.settings.searchBarEnabled
				this.settings.columns = this.init_prepareColumns(this.settings.columns)

				// pager always load next page,
				// next lines force pager to load the correct pageIndex
				if (this.settings.paging.pageIndex >= 0)
					this.settings.paging.pageIndex -= 1

				if (this.settings.defaultSortByCols && this.settings.defaultSortByCols.length)
					this.settings.defaultSortByCols = this.settings.defaultSortByCols.map((col) => _.extend({ name: '', sortState: 'asc', type: 'string' }, col))

				if (editableChanged && this.settings.editable && this.filteredData.length === 0 && this.row_tryAddEmpty())
					this.activeRowIndex = 0

			},
			init_prepareColumns(columns) {
				const state = this.getActiveState(this.settings.stateUID)
				const stateColumns = _.get(state, 'value.columns') || []
				const colState = (colId) =>
					_.head(stateColumns.filter((x) => x.id === colId)) || {}

				let orderCounter = 3

				const defCol = () => ({
					search: {
						enabled: this.settings.searchable === true,
						filter: null,
						keyword: {
							start: '',
							end: '',
						},
						filterType: null,
						filterRemovebtn: false,
						searchable: true,
						prefix: null,
						useTranslate: false,
						translateSplitter: '.',
						items: [],
					},
					sortable: true,
					sortState: 'none',
					entering: true,

					pinnable: true,
					pinned: false,
					fixed: false,
					resizable: true,
					draggable: true,
					droppable: true,
					order: orderCounter++,

					autoGrowWidth: false,
					autoGrowCurrentMinWidth: 0,

					aggregates: [],
					width: 50,
					changeExperimenter: null,
					visibility: true,
					headerCategory: null,

					// align: 'center',
				})

				const defAlignment = (colOption) => {
					if (!colOption.align) {
						if (colOption.type == 'text' || colOption.type == 'string' || colOption.type == 'price' || (!colOption.type && colOption.name != 'rowNumber')) return 'right'
						else return 'center'
					} else return colOption.align
				}

				let idCounter = 1000

				if (this.headerCategoryLength > 0) {
					columns.sort((a, b) => {
						if (!b.headerCategory) {
							if (a.headerCategory !== b.headerCategory) return -1
							if (a.headerCategory === b.headerCategory) return 1
						} else {
							return 0
						}
					})
				}
				columns = columns.map((col) => {
					let columnId = `${col.name}_${idCounter++}`

					var nc = _.merge({}, defCol(), col, colState(columnId))
					nc.align = defAlignment(col)
					nc.aggregates = nc.aggregates.map((a) => {
						return _.extend(
							{
								visible: true,
								// handler: () => null,
								isSystem: false,
								order: 0,
								value: '...',
							},
							a
						)
					})

					nc.orig_width = nc.orig_width || nc.width
					nc.clientOffset = this.col_extractWidth(nc)
					nc.width = nc.clientOffset.basis
					nc.minmaxStyle = this.col_minmaxStyle(nc.clientOffset)
					nc.flexStyle = 'flex: 0 0 auto'
					nc.id = columnId

					let _vm = this
					Object.defineProperty(nc, 'isActive', {
						get() {
							return (
								_vm.activeCol != null &&
								_vm.activeCol.id === nc.id &&
								_vm.isEditable
							)
						},
					})

					return nc
				})

				if (this.headerCategoryLength <= 0) {
					columns.sort((a, b) => {
						if (a.order < b.order) return -1
						if (a.order > b.order) return 1
						return 0
					})
				}
				return columns
			},
			init_calculateRowWidth() {
				if (this.$refs.head == null) {
					return
				}
				const autoWidthColumns = this.getAutoWidthColumns().length
				const hasAutoCol = autoWidthColumns > 0

				let cells = Array.from(
					this.$refs.head.selectAll('> .grid-head-row > .grid-cell')
				)

				let width = cells.reduce((w, cell) => {
					return w + parseFloat(getComputedStyle(cell).width)
				}, 0)

				this.horizontalBoundery = parseFloat(
					getComputedStyle(this.$refs.gridMinbar).width
				)
				if (hasAutoCol && width < this.horizontalBoundery - this.scrollBarWidth) {
					width = this.horizontalBoundery - this.scrollBarWidth
				}

				this.rowWidth = width
			},
			init_syncScrollbars() {
				if (!this.$refs.scroller) {
					return
				}

				let scroller = this.$refs.scroller

				this.col_syncScrolls(scroller, [
					this.$refs.head,
					this.$refs.foot,
					this.$refs['grid-col-indicator'],
				])
			},
			init_refreshRowNumbers(fromRowNumber = 1) {
				let sorter = this.sort_single({
					name: SYSFIELDS_ROWNUMBER,
					sortState: 'asc',
					type: 'number',
				})
				let rows = this.filteredData
					.filter((item) => item[SYSFIELDS_ROWNUMBER] >= fromRowNumber)
					.sort(sorter)

				for (let i = 0; i < rows.length; i++, fromRowNumber++) {
					rows[i][SYSFIELDS_ROWNUMBER] = fromRowNumber
				}
			},
			init_getPureRecords(items, fromRowNumber = 1) {
				let idKey = this.row_IDKey()
				let rowNumber = fromRowNumber

				let data = (items || [])
					.filter((row) => !row.isNew || !this.row_isEmpty(row))
					.map((item, index) => {
						let clone = _.cloneDeep(item)

						if (this.settings.displayOrderEnabled && clone.rowState !== ROW_DELETED) {
							if (!clone.isLocked && clone.displayOrder !== rowNumber && clone.displayOrder != 0) {
								clone.displayOrder = rowNumber
								clone.rowState = clone.rowState === ROW_UNCHANGED ? ROW_CHANGED : clone.rowState
							}

							rowNumber += 1
						}

						if (clone[idKey] < 0) {
							clone[idKey] = emptyId
						}

						return clone
					})

				for (var i = 0; i < data.length; i++) {
					var d = data[i]
					d = _.omit(d, SYSFIELDS_INDEX)
					d = _.omit(d, SYSFIELDS_VALID)
					d = _.omit(d, SYSFIELDS_INVALIDCELLS)
					d = _.omit(d, SYSFIELDS_DIRTYCELLS)
					d = _.omit(d, SYSFIELDS_ANGELS)
					d = _.omit(d, SYSFIELDS_LOCKED)
					d = _.omit(d, SYSFIELDS_ROWNUMBER)
					d = _.omit(d, SYSFIELDS_CHECKED)
					d = _.omit(d, SYSFIELDS_SIZE)
					d = _.omit(d, SYSFIELDS_DISTANCE)

					if (!this.settings.displayOrderEnabled) {
						d = _.omit(d, SYSFIELDS_DISPLAYORDER)
					}

					data[i] = d
				}

				return data
			},
			init_loadDataSource(pager) {
				let model = _.cloneDeep(pager)
				if (
					this.settings.prepareDataSourceModel != null &&
					_.isFunction(this.settings.prepareDataSourceModel)
				) {
					model = this.settings.prepareDataSourceModel(pager)
				}

				return this.settings.dataSource
					.read(model)
					.then((result) => {
						if (result.success) {
							this.init_cloneData(result.data)
						}

						return result
					})
					.catch((error) => {
						if (error.message === 'Invalid endpoint') {
							// do nothing
						} else {
							return error
						}
					})
			},

			table_Focused() {
				this.$el.focus()
				this.table_InnerFocused()
			},
			table_InnerFocused() {
				if (this.disableAutoMoveFocusFirstCol) {
					return
				}
				this.defer(() => {
					this.tableIsFocusOut = false
					if (this.activeRowIndex === -1 && this.filteredData.length > 0) {
						this.activeRowIndex = 0

						if (this.settings.activeRowDisabled) {
							this.focus_selectActiveRow()
						}
					}

					if (this.activeCol) {
						var colIndex = this.filteredColumns.indexOf(this.activeCol)
						colIndex = colIndex > -1 ? colIndex : 0
						this.focus_nextCell(this.activeRowIndex, colIndex)

						if (this.col_isEditable(this.activeCol)) {
							this.nav_leaveRowCell()
						}
					}
				}, 10)
			},
			table_Clicked(e) { },
			table_FocusCheck(state) {
				if (state === 'on') {
					g.events.add(this.$el, 'focusout', this.table_OnFocusout)
				} else {
					g.events.remove(this.$el, 'focusout', this.table_OnFocusout)
				}
			},
			table_OnFocusout() {
				if ($(this.$el).has(':focus').length > 0) {
					return
				}

				this.tableIsFocusOut = true
			},

			row_ID(item) {
				return _.get(item, g.execute(this.settings.row_ID)(item))
			},
			row_IDKey() {
				return g.execute(this.settings.row_ID)()
			},
			row_NewID() {
				this.newRowIdSequence -= 1
				return this.newRowIdSequence
			},
			row_prepareAutoResizeColumns(row) {
				let currentRow = this.filteredData[this.activeRowIndex]

				if (this.row_ID(row) !== this.row_ID(currentRow)) {
					let $row = this.nav_getRowElement(this.row_ID(row))
					if ($row != null) {
						this.col_prepareAutoResizeColumns($row)
					}
				}
			},
			row_isEmpty(row) {
				if (row == null) {
					return true
				}

				let rowIndex = this.filteredData.indexOf(row)
				rowIndex = rowIndex > -1 ? rowIndex : 0
				var newObj = this.row_getEmptyObjectOf(row, rowIndex)
				newObj.id = row.id
				newObj[SYSFIELDS_PAGE] = row[SYSFIELDS_PAGE]
				let idKey = this.row_IDKey()
				var areEqual = _.isEqualWith(row, newObj, (objectVal, otherVal, key) => {
					if (key && key.startsWith(SYSFIELDS_PREFIX)) {
						return true
					} else if (key === idKey && objectVal <= 0 && otherVal <= 0) {
						return true
					}

					if (isEmpty(objectVal) && isEmpty(otherVal)) {
						return true
					}
				})

				return areEqual
			},
			row_deleteRow() {
				var index = this.activeRowIndex

				if (this.row_tryUnDeleteAt(index)) {
					this.focus_focusCurrentLocation()
					return true
				}

				else if (this.row_deleteAt(index) === true) {
					if (this.activeRowIndex >= this.clonedData.length) {
						var created = false

						if (this.clonedData.length === 0) {
							this.activeRowIndex = -1
							this.row_tryAddEmpty(true)
							created = true
						}

						if (this.filteredData.length > 0) {
							this.activeRowIndex = created ? 0 : this.clonedData.length - 1

							if (created) {
								this.defer(() => {
									this.focus_nextCellWithDirection(
										this.activeRowIndex,
										0,
										'direct'
									)
									this.focus_focusCurrentLocation(false, true)

									if (!this.focus_scrollToActiveRow()) {
										this.focus_scrollPage('down')
									}

									this.focus_scrollToActiveCol()
								}, 100)
							}
						} else {
							this.$el.focus()
						}
					}
				}

				return true
			},
			row_addRowAtEnd(button, e, focusFirstCol = true) {
				if ((!this.activeRowIndex && this.activeRowIndex !== 0) || this.activeRowIndex === -1) {
					this.row_tryAddEmptyAt(this.filteredData.length, true, true)
					return
				}
				if (!this.validate_row(this.activeRowIndex)) return
				var index = this.activeRowIndex
				if (index > -1) {
					if (this.activeCol) {
						let activeRow = this.filteredData[index]
						if (
							!this.validate_isCellValid(activeRow, index, this.activeCol)
						) {
							return
						}

						this.nav_leaveCell(index, this.activeCol)
						activeRow[SYSFIELDS_CHECKED] = false
					}
				}

				this.row_tryAddEmpty(true)

				this.defer(() => {
					if (focusFirstCol) {
						this.focus_nextCellWithDirection(
							this.activeRowIndex,
							0,
							'direct'
						)
						this.focus_focusCurrentLocation(false, true)

						if (!this.focus_scrollToActiveRow()) {
							this.focus_scrollPage('down')
						}

						this.focus_scrollToActiveCol()
					}
				}, 100)
				return true
			},
			row_addNewRow() {
				if (this.filteredData.length === 0 || this.activeRowIndex === -1) {
					this.row_tryAddEmptyAt(0, true, true)
					return
				}
				if (!this.validate_row(this.activeRowIndex)) return
				var index = this.activeRowIndex
				if (index > -1) {
					if (this.activeCol) {
						let activeRow = this.filteredData[index]
						if (
							!this.validate_isCellValid(activeRow, index, this.activeCol)
						) {
							return
						}

						this.nav_leaveCell(index, this.activeCol)
						activeRow[SYSFIELDS_CHECKED] = false
					}
				}

				if (this.row_tryAddEmptyAt(index + 1, true)) {
					this.activeRowIndex = index + 1
				}

				return true
			},
			row_tryAddEmpty(focusNewRow = false) {
				if (this.activeRowIndex == null) return false

				let index = -1
				if (this.clonedData) {
					index = this.clonedData.length
				}

				return this.row_tryAddEmptyAt(index, focusNewRow)
			},
			row_tryAddEmptyAt(index, focusNewRow = true, forceAdd = false) {
				if (
					!this.isEditable ||
					(this.settings.allowNewRow !== true && !forceAdd)
				) {
					return false
				}

				index = index >= 0 ? index : 0
				let append = index === this.clonedData.length

				if (!append && index > this.clonedData.length - 1) {
					index = this.clonedData.length - 1
				}

				var newObj = this.row_getEmptyObject(index)

				return this.row_tryAddRecordAt(index, newObj, focusNewRow, forceAdd)
			},
			row_isLocked(row) {
				return row[SYSFIELDS_LOCKED] === true
			},
			row_isDeleted(row) {
				return row[SYSFIELDS_ROWSTATE] === ROW_DELETED
			},
			row_tryUpdateRecordAt(index, obj) {
				if (this.settings.editable !== true) {
					return false
				}

				if (index < 0 || index >= this.clonedData.length) {
					return false
				}

				var row = this.clonedData[index]

				if (!row) {
					return false
				}

				if (this.row_isLocked(row)) {
					return false
				}

				if (this.row_isDeleted(row)) {
					return false
				}

				row = _.mergeWith(row, obj, (objValue, srcValue) => {
					if (Array.isArray(objValue)) {
						return srcValue
					}
				})

				if (row[SYSFIELDS_ROWSTATE] === ROW_UNCHANGED) {
					row[SYSFIELDS_ROWSTATE] = ROW_CHANGED
					row[SYSFIELDS_DIRTYCELLS].tryPush(0)
				}

				return true
			},
			row_tryAddRecordAt(index, newObj, focusNewRow = true, forceAdd = false) {
				if (this.settings.allowNewRow !== true && !forceAdd) {
					return false
				}

				index = index >= 0 ? index : 0
				let append = index === this.clonedData.length

				if (this.search_isTableFiltered()) {
					append = true
				}

				if (!append && index > this.clonedData.length - 1) {
					index = this.clonedData.length - 1
				}

				var row = this.clonedData[index - (append ? 1 : 0)]
				if (this.row_isEmpty(row) && this.clonedData.length > 0) {
					return false
				}
				if (append) {
					this.clonedData.push(newObj)
					this.originalData.push({})

					index = this.filteredData.indexOf(newObj)
				} else {
					this.clonedData.splice(index, 0, newObj)
					this.originalData.splice(index, 0, {})
				}


				this.activeRowIndex = index
				this.init_refreshRowNumbers(newObj[SYSFIELDS_ROWNUMBER])

				if (focusNewRow) {
					this.focus_focusCurrentLocation(false, true)
					// this.defer(this.focus_focusCurrentLocation, 150)
				}

				this.defer(() => {
					let $row = this.nav_getRowElement(this.row_ID(newObj))
					if ($row != null) {
						this.col_prepareAutoResizeColumns($row)
					}
				}, 50)

				this.col_applyAllAggregates()

				return true

			},
			row_getEmptyObject(newItemIndex = 0) {
				var item = null

				if (this.clonedData.length > 0) {
					item = this.clonedData[0]
				}

				return this.row_getEmptyObjectOf(item, newItemIndex)
			},
			row_getEmptyObjectOf(item, newItemIndex = 0) {
				let newObj = g.cloneStructure(item)

				if (this.settings.prepareNewRow) {
					newObj = _.extend(
						{},
						newObj,
						g.execute(this.settings.prepareNewRow)(newObj, newItemIndex)
					)
				}

				// Remove Vue.set API because it was used to add properties to reactive objects which is now handled by vue internally in vue 3
				newObj[SYSFIELDS_ROWNUMBER] = this.row_getRowNumber(newItemIndex)
				newObj[SYSFIELDS_ANGELS] = []
				newObj[SYSFIELDS_VALID] = true
				newObj[SYSFIELDS_INVALIDCELLS] = []
				newObj[SYSFIELDS_DIRTYCELLS] = []
				newObj[SYSFIELDS_LOCKED] = false
				newObj[SYSFIELDS_CHECKED] = false
				newObj[SYSFIELDS_ROWSTATE] = ROW_NEW
				newObj[SYSFIELDS_SIZE] = 30
				newObj[SYSFIELDS_PAGE] = 1
				newObj[this.row_IDKey()] = this.row_NewID()

				Object.defineProperty(newObj, 'isDeleted', {
					get() {
						return newObj[SYSFIELDS_ROWSTATE] === ROW_DELETED
					},
				})

				Object.defineProperty(newObj, 'isNew', {
					get() {
						return newObj[SYSFIELDS_ROWSTATE] === ROW_NEW
					},
				})

				Object.defineProperty(newObj, 'isSelected', {
					get() {
						return newObj[SYSFIELDS_CHECKED] === true
					},
				})

				Object.defineProperty(newObj, 'isLocked', {
					get() {
						return !!newObj[SYSFIELDS_LOCKED]
					},
				})

				return newObj
			},
			row_getClonedObjectAsNew(item, newItemIndex, ignorePrepareNewRow = false) {
				var newObj = item || {}

				if (this.settings.prepareNewRow && !ignorePrepareNewRow) {
					let preparedNewRow = _.isFunction(this.settings.prepareNewRow)
						? this.settings.prepareNewRow(newObj, newItemIndex)
						: this.settings.prepareNewRow
					newObj = _.extend(newObj, preparedNewRow)
				}

				// Remove Vue.set API because it was used to add properties to reactive objects which is now handled by vue internally in vue 3
				newObj[SYSFIELDS_ROWNUMBER] = this.row_getRowNumber(newItemIndex)
				newObj[SYSFIELDS_ANGELS] = []
				newObj[SYSFIELDS_VALID] = true
				newObj[SYSFIELDS_INVALIDCELLS] = []
				newObj[SYSFIELDS_DIRTYCELLS] = []
				newObj[SYSFIELDS_LOCKED] = false
				newObj[SYSFIELDS_CHECKED] = false
				newObj[SYSFIELDS_ROWSTATE] = ROW_NEW

				newObj[this.row_IDKey()] = this.row_NewID()

				Object.defineProperty(newObj, 'isNew', {
					get() {
						return newObj[SYSFIELDS_ROWSTATE] === ROW_NEW
					},
				})

				Object.defineProperty(newObj, 'isSelected', {
					get() {
						return newObj[SYSFIELDS_CHECKED] === true
					},
				})

				newObj.id = emptyId
				newObj.rowState = 'new'
				newObj.rowNumber = newItemIndex
				newObj.displayOrder = newItemIndex

				return newObj
			},
			row_silentDeleteAt(index) {
				if (index < 0 || index >= this.filteredData.length) return false

				var row = this.clonedData[index]
				if (row.isLocked) {
					return false
				}
				this.operation = ''
				if (row.isNew) {
					this.errorCellNames = this.errorCellNames.filter(
						(x) => !x.startsWith(index + '-')
					)
					this.clonedData.splice(index, 1)
					this.originalData.splice(index, 1)
				} else {
					let originalRow = this.originalData[index]
					_.extend(row, originalRow)
					row[SYSFIELDS_DIRTYCELLS] = []
					row[SYSFIELDS_ROWSTATE] = ROW_DELETED
					row.isDisabled = true
				}
				this.value_emit()
				this.$refs.grid_buttons.focus()
				return true
			},
			row_tryUnDeleteAt(index) {
				var row = this.clonedData[index]

				if (index < 0 || index >= this.filteredData.length)
					return false

				if (row.isLocked || row[SYSFIELDS_ROWSTATE] !== ROW_DELETED)
					return false

				row[SYSFIELDS_ROWSTATE] = ROW_UNCHANGED
				row.isDisabled = false
				this.$emit('data-changed', { table: this.filteredData })

				return true
			},
			row_deleteSelectedRows() {
				var index = this.activeRowIndex
				if (this.row_deleteAt(index) === true) {
					if (this.activeRowIndex >= this.clonedData.length) {
						var created = false

						if (this.clonedData.length === 0)
							this.activeRowIndex = -1

						if (this.filteredData.length > 0) {
							this.activeRowIndex = created ? 0 : this.clonedData.length - 1
						} else {
							this.$el.focus()
						}
					}
				}
			},
			row_deleteAt(index) {
				if (index < 0 || index >= this.filteredData.length) return false
				let row = this.filteredData[index]

				if (this.row_silentDeleteAt(index)) {
					if (row.isNew) {
						this.focus_focusCurrentLocation()
						// this.defer(this.focus_focusCurrentLocation(), 1)
					}

					this.$emit('data-changed', { table: this.filteredData })

					this.col_applyAllAggregates()
					return true
				} else {
					return false
				}
			},
			row_getRowNumber(index) {
				let extra = 0
				if (this.settings.paging.enabled === true) {
					extra = this.settings.paging.pageIndex * this.settings.paging.pageSize
				}

				return index + 1 + extra
			},
			row_newRowsCount() {
				return this.filteredData.filter((x) => x[SYSFIELDS_ROWSTATE] === ROW_NEW)
					.length
			},
			row_checkboxClicked(e, row, rowIndex) {
				e.preventDefault()
				this.value_switch(row)

				if (rowIndex) {
					let row = this.filteredData[rowIndex]
					// this.focus_setSilentCurrentLocation({ rowIndex, row })
				}
			},
			row_headerCheckboxClicked(e) {
				e.preventDefault()

				if (this.localValue.length === this.filteredData.length) {
					this.value_removeAll()
				} else {
					this.value_addAll()
				}

				if (!this.settings.activeRowDisabled || this.settings.alwaysEmit) {
					this.value_emit()
				}
			},
			row_getFromOriginal(item) {
				let id = this.row_ID(item)
				return _.head(this.originalData.filter((x) => this.row_ID(x) === id))
			},
			row_validationToast(rowIndex) {

				var base = `${this.$t('row-number')} ${rowIndex + 1}: \n`

				for (var msg of this.errorCellMessages) {
					base += ' - ' + msg.split('[*]')[1] + '\n'
				}

				this.$toast(base, { type: 'error', timeout: Math.min(this.errorCellMessages.length * 2000, 5000), position: 'top-center' })
			},

			col_reverseExtractWidth(clientOffset) {
				let array = []

				if (clientOffset.min) {
					array.push('>' + clientOffset.min)
				}

				if (clientOffset.max) {
					array.push('<' + clientOffset.max)
				}

				if (clientOffset.basis) {
					array.push(clientOffset.basis)
				}

				return array.join('|')
			},

			col_extractWidth(col) {
				let pattern = col.width || col.orig_width

				let min = 50
				let offset = {
					min: min + 'px',
					max: null,
					basis: 'auto',
					auto: false,
				}

				if (pattern) {
					if (_.isNumber(pattern)) {
						let w = pattern < min ? min : pattern
						offset.basis = w += 'px'
					} else if (_.isString(pattern)) {
						let parts = pattern.split('|')
						for (var i = 0; i < parts.length; i++) {
							let p = parts[i]

							if (p.startsWith('<')) {
								offset.max = p.substring(1).replace('px', '').trim()
							} else if (p.startsWith('>')) {
								offset.min = p.substring(1).replace('px', '').trim() + 'px'
							} else {
								offset.basis = p

								if (p === 'auto') {
									offset.auto = true
								}

								if (_.isNumber(p)) {
									offset.basis += 'px'
								}
							}
						}
					}
				}

				if (offset.auto === true) {
					offset.basis = 'auto'
				}

				return offset
			},
			col_minmaxStyle(offset) {
				var styles = []

				if (offset.min != null) {
					styles.push(`min-width: ${offset.min}`)
				}
				if (offset.max != null) {
					styles.push(`max-width: ${offset.max}`)
				}
				return styles.join('; ')
			},
			col_validateColConfig(col, config) {
				if (!config.component) {
					console.warn(
						`table column '${col.name}' has not provided any component.`
					)
				}

				return config
			},
			col_edit(row, col) {
				col.component = this.makeRawComponent(col.component)
				return this.col_validateColConfig(
					col,
					_.isFunction(col.edit) ? col.edit(row, col) : col.edit || {}
				)
			},
			col_view(row, col) {
				col.component = this.makeRawComponent(col.component)
				let config = _.isFunction(col.view) ? col.view(row, col) : col.view

				if (!config)
					return null

				if (!config.component) {

					if (!row[col.name])
						return { value: '' }

					var value = row[col.name]

					if (config.options) {

						if (config.options.format && _.isFunction(config.options.format))
							return { value: config.options.format(value) }

						if (config.options.type)
							return { value: textVisualizer(value, config.options) }
					}
				}

				return config
			},
			col_getProp(row, col) {
				return _.get(row, col.name)
			},
			col_setProp(row, col, val) {
				_.set(row, col.name, val)
				this.$emit('data-changed', { column: col.name, val: val, table: this.filteredData })
			},
			col_getCell(row, col) {
				if (!row || !col) return

				let $cell

				let $row = this.nav_getRowElement(this.row_ID(row))
				if ($row != null) {
					$row
						.querySelectorAll(
							`.grid-cell[data-grid-id="${this.gridId}"][data-id="${col.id}"]`
						)
						.forEach((cell) => {
							$cell = cell
						})
				}

				return $cell
			},
			col_prepareAutoResizeColumns($row) {
				$row
					.querySelectorAll(`.grid-cell[data-grid-id="${this.gridId}"]`)
					.forEach(this.col_rebindAutoResizeEvent)
			},
			col_unbindAutoResizeColumns($row) {
				$row
					.querySelectorAll(`.grid-cell[data-grid-id="${this.gridId}"]`)
					.forEach((cell) => {
						let id = cell.getAttribute('data-id')
						let col = _.head(this.settings.columns.filter((x) => x.id === id))
						if (!col.autoGrowWidth) return

						let $content = cell.querySelector('.grid-cell-content :first-child')
						g.events.clear($content, 'resize')
					})
			},
			col_rebindAutoResizeEvent(cell) {
				let id = cell.getAttribute('data-id')
				let col = _.head(this.filteredColumns.filter((x) => x.id === id))
				if (!col || !col.autoGrowWidth) return

				let $content = cell.select('> .grid-cell-content > :first-child')
				g.events.add($content, 'resize', (event) => {
					let width = parseFloat(getComputedStyle($content).width)
					if (
						width >= col.autoGrowCurrentMinWidth ||
						col.autoGrowCurrentMinWidth === 'auto'
					) {
						col.autoGrowCurrentMinWidth = width
						col.width = width
						cell.setAttribute('data-width', width)
						this.col_setWidth(cell, width)
					}
				})
			},
			col_setWidth(cell, width) {
				let target = cell.select('> .grid-cell-content > :first-child')
				let targetComputedStyle = getComputedStyle(target)
				let oldWidth = parseInt(targetComputedStyle.width, 10)

				this.col_applyToColumn(cell, (c) => {
					c.select('> .grid-cell-content').style.width = width + 'px'
				})

				let widthDif = width - oldWidth
				if (cell.classList.contains('frozen')) {
					let row = cell.parentElement

					let frozenCells = this.col_sortCellsByOrder(
						row.selectAll('> .grid-cell')
					)
					if (frozenCells.length) {
						let positionStart = 0
						frozenCells.forEach((currentCell) => {
							if (currentCell.classList.contains('frozen')) {
								currentCell.setAttribute('data-distance', positionStart)
							} else {
								let cellStyle = getComputedStyle(currentCell)
								let cellWidth = parseInt(cellStyle.width, 10)
								positionStart += cellWidth
								currentCell.removeAttribute('data-distance')
							}
						})
					}
				}

				this.rowWidth += widthDif
				// this.row_setRowElementWidth(this.rowWidth)

				// this.init_calculateRowWidth()

				let id = cell.getAttribute('data-id')
				let col = _.head(this.settings.columns.filter((x) => x.id === id))

				col.width = width

				this.defer(() => {
					this.init_prepareFrozenCells()
					this.defer(() => {
						this.init_syncScrollbars()
					}, 150)
				}, 150)
			},
			col_pin(col) {
				if (col.pinnable !== true) return

				col.pinned = !col.pinned

				this.init_prepareFrozenCells()

				this.$nextTick(() => {
					this.init_syncScrollbars()
				})
			},
			col_applyAggregates(col, onlySelecteds = false) {
				if (this.filteredData == null) {
					return
				}
				col.aggregates = col.aggregates.sort2('order')
				for (let agg of col.aggregates.filter(
					(x) => x.visible && _.isFunction(x.handler)
				)) {
					if (!onlySelecteds)
						agg.value = agg.handler(this.filteredData, col, this.settings)
					agg.valueForSelecteds = (this.localValue || []).length > 1 ? agg.handler(this.localValue, col, this.settings) : ''//display selected aggregates when seleted item more than one
				}
			},
			col_applyAllAggregates(onlySelecteds = false) {
				if (this.filteredData == null) {
					return
				}

				if (this.$refs.aggregate) {
					for (let aggregate of this.$refs.aggregate) {
						const selected = aggregate.aggregateSelect
						aggregate.setDefaultAggregates(selected)
					}
				}

				for (let col of this.filteredColumns) {
					this.col_applyAggregates(col, onlySelecteds)
				}
			},
			col_isEditable(col) {
				let row = this.filteredData[this.activeRowIndex]
				if (!row) {
					return false
				}

				if (
					!this.isEditable ||
					col.editable == null ||
					row[SYSFIELDS_LOCKED] === true ||
					row[SYSFIELDS_ROWSTATE] === ROW_DELETED ||
					col.id === 'rowNumber_1000'
				) {
					return false
				}

				return _.isFunction(col.editable) ? col.editable(row, col) : !!col.editable
			},
			col_getFirstOrLastEditableColumn(target) {
				if (target === 'first') {
					return this.filteredColumns.findIndex(col => col.visibility === true && this.col_isEditable(col))
				} else {
					return this.filteredColumns.findLastIndex(col => col.visibility === true && this.col_isEditable(col))
				}
			},
			col_isSortable(col) {
				if (this.settings.sortable && col.sortable !== false) {
					return true
				} else {
					return false
				}
			},
			col_isRowNumber(col) {
				return col.name && col.name.toLowerCase() === 'rownumber'
			},
			col_isInDirtyList(row, colId) {
				return row[SYSFIELDS_DIRTYCELLS].indexOf(colId) > -1
			},
			col_isInErrorList(rowIndex, colId) {
				return (
					this.errorCellNames.indexOf(this.col_getCellUID(rowIndex, colId)) > -1
				)
			},
			col_getCellUID(rowIndex, colId) {
				return `${rowIndex}-${colId}`
			},
			col_isChanged(rowIndex, col) {
				if (col.name == 'rowNumber')
					return false
				var clonedRow = this.filteredData[rowIndex]
				var originalRow = this.row_getFromOriginal(clonedRow)

				var originalCell = originalRow ? _.get(originalRow, col.name) : {}
				var clonedCell = _.get(clonedRow, col.name)

				var experimenter = (
					objectVal,
					otherVal,
					key,
					firstObject,
					otherObject
				) => {
					if (isEmpty(objectVal) && isEmpty(otherVal)) {
						return true
					}

					if (_.isFunction(col.changeExperimenter)) {
						return col.changeExperimenter(
							objectVal,
							otherVal,
							key,
							firstObject,
							otherObject
						)
					}
				}

				return !_.isEqualWith(originalCell, clonedCell, experimenter)
			},
			col_applyToColumn(cell, func) {
				var id = cell.getAttribute('data-id')
				this.col_applyToColumnByColId(id, func)
			},
			col_applyToColumnByColId(id, func) {
				this.$el
					.querySelectorAll(`[data-grid-id="${this.gridId}"][data-id="${id}"]`)
					.forEach(function (currentCell) {
						func(currentCell)
					})
			},
			col_sortCellsByOrder(cells, mode) {
				mode = mode === 'desc' ? 'desc' : 'asc'

				function sorter(first, second) {
					var order1 = parseInt(first.style.order, 10)
					var order2 = parseInt(second.style.order, 10)

					if (order1 > order2) {
						return mode === 'desc' ? -1 : +1
					} else if (order1 < order2) {
						return mode === 'desc' ? +1 : -1
					} else {
						return 0
					}
				}

				var array = Array.from(cells)
				array.sort(sorter)

				return array
			},
			col_scrollTo(col) {
				if (col == null) {
				}

				// var offset = this.col_position(col)
				// var $scroller = $(this.$refs.hscroller)

				/// / the table might already is destroyed
				// if ($scroller.length === 0) {
				//  return
				// }

				// if (col.pinned) {
				//  // if you enable this, table force to scroll to first pinned column with every click on table!
				//  //$scroller.scrollRight(0)
				// } else {
				//  var left = offset.right + parseFloat(col.width)

				//  var rv = this.col_isVisible(offset.right)
				//  var lv = this.col_isVisible(left)

				//  if (!rv || !lv) {
				//    $scroller.scrollRight(offset.right)
				//  }
				// }
			},
			col_syncScrolls(source, targets) {
				if (!Array.isArray(targets)) {
					targets = [targets]
				}
				// const baseScrollLeft = source.scrollWidth - source.offsetWidth
				// const scrollBarWidth = this.scrollBarWidth

				var frozens = []

				const keepFrozens = (moved, backward) => {
					frozens.forEach((item) => {
						const colId = item.cell.getAttribute('data-id')
						const isRowIndicator = colId === 'rowIndicator'
						const col = this.filteredColumns.filter(
							(x) => x.id === item.cell.getAttribute('data-id')
						)[0]
						const isFirstOrRow = isRowIndicator || (col || {}).order <= 2
						let distance = item.distance
						if (distance > 0) {
							if (distance <= Math.abs(moved) && !isFirstOrRow) {
								this.col_applyToColumn(item.cell, (c) => {
									c.style.transform = `translateX(-${moved - distance}px)`
									c.classList.add('transformed')
								})
							} else {
								this.col_applyToColumn(item.cell, (c) => {
									c.style.transform = `translateX(0px)`
									c.classList.remove('transformed')
								})
							}
						} else {
							this.col_applyToColumn(item.cell, (c) => {
								c.style.transform = `translateX(-${moved}px)`
								if (moved !== 0) {
									c.classList.add('transformed')
								} else {
									c.classList.remove('transformed')
								}
							})
						}
					})
				}

				const scrolled = (ev) => {
					let left = ev.target.scrollLeft >= 0 ? 0 : ev.target.scrollLeft * -1
					let top = ev.target.scrollTop < 0 ? 0 : ev.target.scrollTop

					let prevTop = parseFloat(source.getAttribute('data-top')) || 0
					if (top !== prevTop) {
						source.setAttribute('data-top', top)
						$(this.$refs.head).css('transform', 'translateY(' + top + 'px)')
						$(this.$refs.foot).css('transform', 'translateY(' + top + 'px)')
					}

					let prevLeft = parseFloat(source.getAttribute('data-left'))
					if (left !== prevLeft) {
						frozens = this.$refs.head
							.selectAll('> .grid-head-row > .grid-cell.frozen')
							.map((cell) => {
								return {
									cell,
									distance: parseFloat(cell.getAttribute('data-distance') || '0'),
								}
							})
						source.setAttribute('data-left', left)
						keepFrozens(left, left > prevLeft)

						if (this.$refs.nodata)
							this.$refs.nodata.style.transform = `translateX(-${left}px)`
						if (this.$refs.preparing)
							this.$refs.preparing.style.transform = `translateX(-${left}px)`

						let transformed = this.col_sortCellsByOrder(
							frozens
								.filter((x) => x.cell.classList.contains('transformed'))
								.map((x) => x.cell)
						)
						if (transformed.length > 0) {
							transformed.forEach((cell, index) => {
								if (index === transformed.length - 1) {
									this.col_applyToColumn(cell, (c) => {
										c.classList.add('last')
									})
								} else {
									this.col_applyToColumn(cell, (c) => {
										c.classList.remove('last')
									})
								}
							})
						}
					}
				}

				g.events.replace(source, 'scroll', scrolled)
			},
			col_setActiveCol(colName) {
				let col = this.settings.columns.find((x) => x.name == colName)
				if (col) this.activeCol = col
			},

			value_switch(item) {
				var has = this.value_any(item)
				if (has) {
					this.value_remove(item)
				} else {
					this.value_add(item)
				}
			},
			value_add(item, clear) {
				if (clear === true) {
					this.value_removeAll()
				}

				if (item == null) {
					return false
				}

				item[SYSFIELDS_CHECKED] = true

				if (!this.settings.activeRowDisabled || this.settings.alwaysEmit) {
					this.value_emit()
				}

				return true
			},
			value_remove(item) {
				if (item == null) {
					return false
				}

				item[SYSFIELDS_CHECKED] = false

				if (!this.settings.activeRowDisabled || this.settings.alwaysEmit) {
					this.value_emit()
				}

				return true
			},
			value_addAll() {
				this.value_removeAll()

				for (let i = 0; i < this.filteredData.length; i++) {
					this.filteredData[i][SYSFIELDS_CHECKED] = true
				}

				this.col_applyAllAggregates(true)
			},
			value_removeAll() {
				let checkeds = this.localValue
				for (let i = 0; i < checkeds.length; i++) {
					checkeds[i][SYSFIELDS_CHECKED] = false
				}

				this.col_applyAllAggregates(true)
			},
			value_reverse() {
				for (let i = 0; i < this.filteredData.length; i++) {
					this.filteredData[i][SYSFIELDS_CHECKED] = !this.filteredData[i][SYSFIELDS_CHECKED]
				}

				this.col_applyAllAggregates(true)

				if (!this.settings.activeRowDisabled || this.settings.alwaysEmit) {
					this.value_emit()
				}
			},
			value_any(item) {
				if (item == null) {
					return false
				}

				return !!item[SYSFIELDS_CHECKED]
			},
			value_emit() {
				var pure = this.init_getPureRecords(this.localValue)
				if (this.settings.multiselection === true) {
					this.$emit('update:modelValue', pure)
				} else {
					this.$emit('update:modelValue', _.head(pure))
				}
			},
			value_tryAdd(item, clear) {
				let validItem = item

				if (!_.has(item, SYSFIELDS_CHECKED)) {
					validItem = _.head(
						this.filteredData.filter((x) => this.row_ID(x) === this.row_ID(item))
					)
				}

				if (validItem) {
					return this.value_add(validItem, clear)
				} else {
					this.notFoundValueItems.push(item)
					return false
				}
			},
			value_indeterminate(enabled) {
				if (enabled) {
					this.headCheckboxIcon = Checkbox.Intermediate
				} else {
					this.headCheckboxIcon = Checkbox.Empty
				}
			},
			value_snapshot() {
				let items = this.init_getPureRecords(this.localValue)

				if (this.settings.multiselection === true) {
					return items
				} else {
					return _.head(items)
				}
			},
			value_preserve() {
				let snapshot = this.value_snapshot()

				if (snapshot) {
					snapshot = this.settings.multiselection ? snapshot : [snapshot]
				} else {
					snapshot = []
				}

				this.preservedValue = snapshot.concat(this.notFoundValueItems)
				this.notFoundValueItems = []
			},
			value_loadPreserved() {
				if (this.preservedValue != null) {
					for (let i = 0; i < this.preservedValue.length; i++) {
						this.value_tryAdd(this.preservedValue[i], i === 0)
					}

					this.preservedValue = null
				}
			},

			nav_leavingCell(row, col, table) {
				let leave = null
				if (row == null || !row) {
					if (col == null && col.leaving == null) {
						leave = false
					}
					return leave
				}

				if (col != null && col.leaving != null) {
					leave = true

					if (_.isFunction(col.leaving)) {
						leave = !!col.leaving(row, col, table)
					} else {
						leave = !!col.leaving
					}

					return leave
				}

				return true
			},
			nav_leavingRow() {
				// TODO validate
				return true
			},
			nav_leaveCell(rowIndex, col) {
				if (rowIndex <= -1) {
					throw new Error('undefined active row')
				}

				let clonedRow = this.filteredData[rowIndex]

				if (typeof clonedRow[SYSFIELDS_VALID] == 'undefined')
					clonedRow[SYSFIELDS_VALID] = true

				if (!clonedRow[SYSFIELDS_DIRTYCELLS])
					clonedRow[SYSFIELDS_DIRTYCELLS] = []

				if (this.col_isChanged(rowIndex, col)) {
					clonedRow[SYSFIELDS_DIRTYCELLS].tryPush(col.id)

					if (clonedRow[SYSFIELDS_ROWSTATE] === ROW_UNCHANGED) {
						clonedRow[SYSFIELDS_ROWSTATE] = ROW_CHANGED
					}
				} else {
					if (clonedRow[SYSFIELDS_DIRTYCELLS].tryRemove(col.id)) {
						if (
							clonedRow[SYSFIELDS_DIRTYCELLS].length === 0 &&
							clonedRow[SYSFIELDS_ROWSTATE] === ROW_CHANGED
						) {
							clonedRow[SYSFIELDS_ROWSTATE] = ROW_UNCHANGED
						}
					}
				}

				if (this.isEditable) {
					this.col_applyAllAggregates()
				}

				return true
			},
			nav_getRowElement(rowId) {
				let $row = this.$el.querySelector('.grid-row[data-row="' + rowId + '"]')
				return $row
			},
			nav_leaveRowCell() {
				let done = !!this.filteredData && this.filteredData.length

				let row = this.filteredData[this.activeRowIndex]
				let col = this.activeCol

				done = done && !!row && !!col
				done = done && this.nav_leavingCell(row, col, this.filteredData)
				done = done && this.nav_leaveCell(this.activeRowIndex, col)
				done = done && this.nav_leavingRow()

				return done
			},

			validate_row(rowIndex) {
				if (rowIndex < 0 || rowIndex >= this.clonedData.length) {
					return false
				}

				var valid = this.validate_isRowValid(rowIndex)
				this.clonedData[rowIndex][SYSFIELDS_VALID] = valid

				this.clonedData[rowIndex][SYSFIELDS_INVALIDCELLS] = this.errorCellNames
					.filter((x) => x.startsWith(rowIndex + '-'))
					.map((x) => x.substring(2))

				if (!valid)
					this.row_validationToast(rowIndex)

				return valid
			},
			validate_isRowValid(rowIndex) {
				if (rowIndex < 0) {
					return false
				}

				var valid = true

				let activeRow = this.filteredData[rowIndex]
				if (activeRow.isLocked) {
					return true
				}

				var cols = this.filteredColumns.filter(
					(x) => x.validators != null && x.validators.length > 0
				)
				for (var i = 0; i < cols.length; i++) {
					var c = cols[i]
					if (this.validate_isCellValid(activeRow, rowIndex, c) === false) {
						valid = false
					}
				}

				return valid
			},
			validate_isCellValid(row, rowIndex, col) {
				if (!row) {
					return false
				}

				var uid = this.col_getCellUID(rowIndex, col.id)

				this.errorCellMessages = this.errorCellMessages.filter(
					(x) => !x.startsWith(uid)
				)

				if (
					col != null &&
					col.validators != null &&
					$.isArray(col.validators) &&
					col.validators.length > 0
				) {
					row = this.clonedData[rowIndex]
					var cellValue = _.get(row, col.name)

					if (row != null) {
						var vs = col.validators.filter((x) => x instanceof Validator)
						for (var i = 0; i < vs.length; i++) {
							var v = vs[i]
							if (!v.test(cellValue, row)) {
								this.errorCellNames.tryPush(uid)
								if (_.isFunction(v.error)) {
									this.errorCellMessages.tryPush(uid + '[*]' + v.error(col.title, row))
								}
								return false
							}
						}
					}
				}

				this.errorCellNames.tryRemove(uid)

				return true
			},

			focus_selectCurrentLocation(rowIndex, row, col, focusSearchRow, dblClick) {
				this.focus_setCurrentLocation(
					rowIndex,
					row,
					col,
					focusSearchRow,
					dblClick
				)
				var item = this.filteredData[this.activeRowIndex]
				this.value_add(item, true)
			},
			focus_setCurrentLocation(rowIndex, row, col, focusSearchRow, dblClick) {
				this.focus_setSilentCurrentLocation({ rowIndex, col, dblClick })

				if (focusSearchRow === true) {
					this.activeCol = col
					this.focus_focusCurrentLocation(focusSearchRow)
				} else {
					var colIndex = this.filteredColumns.indexOf(col)
					colIndex = colIndex > -1 ? colIndex : 0
					this.focus_nextCellWithDirection(rowIndex, colIndex, 'direct')
				}
			},
			focus_setSilentCurrentLocation({ rowIndex, col, dblClick } = {}) {
				//if (rowIndex === this.activeRowIndex && col && col.isActive) {
				//  return
				//}
				if (rowIndex === this.activeRowIndex && !dblClick && !this.isEditable) {
					var item = this.filteredData[this.activeRowIndex]
					this.value_remove(item)
					this.activeRowIndex = -1
					return
				}

				this.activeRowIndex = rowIndex

				if (this.settings.activeRowDisabled) {
					this.focus_selectActiveRow()
				} else if (this.settings.alwaysEmit) {
					this.value_add(this.filteredData[rowIndex], true)
				}
			},
			focus_focusCurrentLocation(focusSearchRow, insertRow = false) {
				if (focusSearchRow === true) {
					this.$refs['search-row'].select('.grid-cell.col-active input').focus()
					return
				}
				var editable = this.activeCol && this.col_isEditable(this.activeCol)

				this.$nextTick(async () => {
					let row
					let target
					const findRow = () => {
						row = row || this.$el.select(DIRECT_ROW_SELECTOR + '.grid-row-active')
						return row = row || this.$el.select(DIRECT_ROW_SELECTOR + '.grid-row')
					}
					const waitForRenderCell = () => {
						return new Promise((res, rej) => {
							const interval = setInterval(() => {
								if (this.cell_mounted) {
									clearInterval(interval)
									res()
								}
							}, 10)
							setTimeout(() => {
								rej()
								clearInterval(interval)
							}, 500)
						})
					}
					this.focus_scrollToActiveRow()
					if (insertRow) {
						await waitForRenderCell().catch(er => { })
						if (!this.activeCol || this.activeCol.id === 'rowNumber_1000') {
							this.activeCol = this.filteredColumns.find(x => this.col_isEditable(x))
						}
						editable = this.activeCol && this.col_isEditable(this.activeCol)
					}
					row = findRow()
					if (row == null) {
						return
					}
					if (editable) {
						target = row.querySelector(
							`.grid-cell[data-id="${this.activeCol.id}"] .nk-control`
						)
						if (target == null) {
							await waitForRenderCell().catch(er => { })
							target = row.querySelector(
								`.grid-cell[data-id="${this.activeCol.id}"] .nk-control`
							)
						}
						if (target == null)
							target = row.querySelector(
								`.grid-cell[data-id="${this.activeCol.id}"] input`
							)
					} else {
						target = row.querySelector(
							`.grid-cell[data-id="${this.activeCol.id}"] [tabindex="0"]`
						)
					}
					if (target == null) {
						target = row.querySelector(
							`.grid-cell[data-id="${this.activeCol.id}"] div[tabindex="0"]:nth-child(1)`
						)
					}
					if (target == null) {
						target = row.querySelector(
							'.grid-cell:first-child input, .grid-cell:first-child [tabindex="0"]'
						)
					}
					if (target != null) {
						target.focus()
						const rowData = this.clonedData[this.activeRowIndex]
						this.activeCol && _.isFunction(this.activeCol.entering) && this.activeCol.entering(rowData, this.activeCol)
					}
					// }



				})
			},
			focus_nextSearchCell(direction) {
				let index = this.filteredColumns.indexOf(this.activeCol)

				if (direction === 'next') {
					if (index < this.filteredColumns.length - 1) {
						index += 1
					} else {
						index = 0
					}
				} else {
					if (index > 0) {
						index -= 1
					} else {
						index = this.filteredColumns.length - 1
					}
				}

				let nextCol = this.filteredColumns[index]

				this.$nextTick(() => {
					this.col_scrollTo(nextCol)

					this.activeCol = nextCol
					this.defer(() => this.focus_focusCurrentLocation(true), 1)
				})
			},
			focus_scrollToActiveRow() {
				let currentRow = this.filteredData[this.activeRowIndex]
				let $row = this.nav_getRowElement(this.row_ID(currentRow))
				if ($row != null) {
					$(this.$el).find('.scroller').scrollTo($row)
					return true
				} else {
					return false
				}
			},
			focus_scrollToActiveCol() {
				this.col_scrollTo(this.activeCol)
			},
			focus_scrollTop() {
				let currentRow = this.filteredData[0]
				let $row = this.nav_getRowElement(this.row_ID(currentRow))
				if ($row != null) {
					$(this.$el).find('.scroller').animate({ scrollTop: 0 })
					// $(this.$el).find('.scroller').scrollTop(0)
					return true
				} else {
					return false
				}
			},
			focus_scrollPage(direction) {
				let $scroller = $(this.$el).find('.scroller')
				let distance = $(this.$refs.bodyContent).height() / 1.5

				let scrollTop = $scroller.scrollTop()
				if (direction === 'up') {
					scrollTop -= distance
				} else {
					scrollTop += distance
				}

				$scroller.scrollTop(scrollTop)
				this.focus_activateFirstVisibleRow()
			},
			focus_activateFirstVisibleRow() {
				let $scroller = $(this.$el).find('.scroller')

				let trans = $scroller
					// .find('.vue-recycle-scroller__item-view')
					.map((index, el) => {
						let arr = $(el)
							.css('transform')
							.replace('matrix(', '')
							.split(',')
							.map((x) => parseFloat(x))
						let y = arr[arr.length - 1]

						return {
							el,
							y,
						}
					})
					.filter((index, item) => item.y >= 0)
				if (!trans || trans.length == 0)
					return
				trans = _.sortBy(trans, (item) => item.y)
				let middle = Math.floor(trans.length / 2)
				let row = trans[middle < trans.length ? middle : 0].el

				let id = $(row).find('.grid-row').attr('data-row')
				let index = this.filteredData.findIndex((x) => x.id === id)

				if (index > -1) {
					this.activeRowIndex = index
				}
			},
			focus_activateRowByValue() {
				if (this.localValue.length > 0) {
					this.activeRowIndex = this.filteredData.findIndex(
						(item) => this.row_ID(item) === this.row_ID(this.localValue[0])
					)
				} else {
					this.activeRowIndex = this.filteredData.length > 0 ? 0 : -1
				}
			},
			focus_cellClicked(rowIndex, row, col, focusSearchRow) {
				this.operation = 'cellclick'
				const click = async (rowIndex, row, col, focusSearchRow) => {
					let prevRowIndex = this.activeRowIndex

					if (this.temporaryReadonly === true) {
						this.temporaryReadonly = false
						this.activeRowIndex = rowIndex
					}

					if (this.isEditable && prevRowIndex > -1) {
						let prevRow = this.filteredData[prevRowIndex]

						// check leave cell
						if (! await this.nav_leavingCell(prevRow, this.activeCol, this.filteredData)) {
							return true
						}

						// check leave row
						if (rowIndex !== prevRowIndex && !this.validate_row(prevRowIndex)) {
							return true
						}

						// leave cell
						this.nav_leaveCell(prevRowIndex, this.activeCol)
					}

					// if (rowIndex < this.filteredData.length) {
					// 	this.value_add(this.filteredData[rowIndex], true)
					// }

					// focus clicked cell
					if (this.col_isEditable(col)) {
						this.focus_setCurrentLocation(rowIndex, row, col, focusSearchRow)
						this.value_add(this.filteredData[rowIndex], true)
					} else {
						this.focus_setSilentCurrentLocation({
							rowIndex,
							row,
							col,
							focusSearchRow,
						})
					}
				}

				if (
					rowIndex === this.activeRowIndex &&
					col === this.activeCol &&
					!focusSearchRow &&
					this.isEditable
				) {
					return false
				}
				this.value_removeAll()
				click(rowIndex, row, col, focusSearchRow)
			},
			focus_cellDblClicked(rowIndex, row, col, focusSearchRow) {
				if (this.temporaryReadonly === true) {
					this.temporaryReadonly = false
					this.activeRowIndex = rowIndex

					if (rowIndex < this.filteredData.length) {
						this.value_add(this.filteredData[rowIndex], true)
					}
				}

				if (this.errorCellNames.length > 0) {
					return
				}

				this.focus_selectCurrentLocation(rowIndex, row, col, focusSearchRow, true)

				if (!this.isEditable && this.settings.activeRowDisabled === true) {
					var clonedRow = this.filteredData[this.activeRowIndex]

					if (clonedRow.isSelected) {
						this.value_emit()
					}
				}
			},
			focus_selectActiveRow() {
				var item = this.filteredData[this.activeRowIndex]
				if (!this.value_any(item)) {
					this.value_add(item, true)
				}
			},
			focus_activeSelectedRow() {
				if (this.localValue && this.localValue.length > 0) {
					var first = this.localValue.filter((x) => x.isSelected)
					first = first.length > 0 ? first[0] : null

					var hasData = !!(this.filteredData && this.filteredData.length)
					var id = this.row_ID(first)

					if (first != null && hasData) {
						var index = this.filteredData.findIndex((x) => this.row_ID(x) === id)
						this.defer(() => {
							if (index > -1) {
								this.activeRowIndex = index
							} else {
								this.localValue = [this.filteredData[0]]
								this.activeRowIndex = 0
							}

							this.defer(() => {
								this.focus_scrollToActiveRow()
								this.focus_scrollToActiveCol()
							}, 5)
						}, 5)

						return
					}
				}

				this.activeRowIndex = hasData > 0 ? 0 : -1
			},
			focus_nextCell(rowIndex, colIndex) {
				return this.focus_nextCellWithDirection(rowIndex, colIndex, 'right')
			},
			focus_nextCellWithDirection(rowIndex, colIndex, direction) {
				var cycled = false

				const nextCol = (ri, ci, dir) => {
					if (ci >= this.filteredColumns.length) {
						// if (this.validate_isRowValid(ri)) {
						//  return 'next-row'
						// }

						ci = 0
						cycled = true
					}

					if (cycled && ci === colIndex) {
						return
					}

					if (this.clonedData == null) {
						return false
					}

					var row = this.clonedData[ri]
					var col = this.filteredColumns[ci]

					if (row == null || col == null) {
						return false
					}

					var allow = col.visibility ? _.isFunction(col.entering)
						? col.entering(row, col, dir)
						: col.entering : false

					if (allow) {
						return col
					} else {
						return nextCol(ri, ci + 1, 'right')
					}
				}

				var col = nextCol(rowIndex, colIndex, direction)
				if (col === 'next-row') {
					if (direction === 'direct') {
						return false
					}

					const goNextRow = () => {
						rowIndex += 1 // next row
						if (
							this.filteredData.length <= rowIndex &&
							(!this.isEditable || this.settings.allowNewRow !== true)
						) {
							rowIndex -= 1
						}

						var inRange = this.filteredData.length > rowIndex
						var newItemAdded = !inRange && this.row_tryAddEmpty()

						if (inRange || newItemAdded) {
							this.validate_row(this.activeRowIndex)
							this.activeRowIndex = rowIndex
							return true
						}

						return false
					}

					if (goNextRow()) {
						return this.focus_nextCellWithDirection(rowIndex, 0, 'right')
					} else {
						return false
					}
				} else if (col) {
					this.col_scrollTo(col)

					this.activeCol = col
					this.defer(() => {
						this.focus_focusCurrentLocation()

						let row = this.filteredData[rowIndex]
						let $cell = this.col_getCell(row, col)
						if ($cell != null) {
							this.col_rebindAutoResizeEvent($cell)
						}
					}, 1)
					return true
				} else {
					return false
				}
			},
			focus_prevCell(rowIndex, colIndex) {
				if (colIndex >= this.filteredColumns.length) {
					return false
				}

				var row = this.clonedData[rowIndex]
				var col = this.filteredColumns[colIndex]

				if (row == null || col == null) {
					return false
				}

				var allow =
					col.name !== SYSFIELDS_ROWNUMBER &&
					(_.isFunction(col.entering)
						? col.entering(row, col, 'left')
						: col.entering)

				if (allow === false || colIndex === 0) {
					return this.focus_prevCell(rowIndex, colIndex - 1)
				} else {
					this.col_scrollTo(col)

					this.activeCol = col
					this.defer(this.focus_focusCurrentLocation, 1)
					return true
				}
			},
			focus_scrollToFirstCell() {
				let col = _.head(this.filteredColumns.filter((x) => !x.pinned))
				if (col) {
					this.col_scrollTo(col)
				}
			},
			focus_cellClickedByCtrl(row) {
				if (!this.settings.multiselection)
					this.value_removeAll()
				row.$___checked = !row.$___checked
				this.activeRowIndex = -1
				this.col_applyAllAggregates(true)
				this.value_emit()
			},
			search_col(data, col) {
				if (col.search.filter) return col.search.filter.apply(this, [data, col])
				col.search.searchFields = !Array.isArray(col.search.searchFields) ? _.concat([], col.search.searchFields) : col.search.searchFields
				switch (col.type) {
					case 'pdate':
						return this.search_pdate(data, col)
					case 'number':
					case 'price':
						return this.search_number(data, col)
					default:
						return this.search_text(data, col)
				}
			},
			search_array(data, col, act) {
				return col.search.searchFields.map((searchFields) => {
					return data[col.name].findIndex((found) => {
						let query = _.get(found, searchFields)
						if (col.search.useTranslate)
							query = this.translate(col, query)
						query = col.type === 'pdate' ? this.convertDate2Persian(query) : query
						if (this.isObject(query) && Array.isArray(col.search.subSearchField)) return col.search.subSearchField.some(x => act(_.get(query, x)))
						return query && act(query)
					}) > -1
				}).some(result => result === true)
			},
			search_object(data, col, act) {
				return col.search.searchFields.map((searchField) => {
					let query = _.get(data[col.name], searchField)
					if (col.search.useTranslate)
						query = this.translate(col, query)
					query = col.type === 'pdate' ? this.convertDate2Persian(query) : query
					if (Array.isArray(query) && Array.isArray(col.search.subSearchField)) return query.some(x => col.search.subSearchField.some(y => act(x[y])))
					return query && act(query)
				}).some(result => result === true)
			},
			search_text(data, col) {
				let p = null
				switch (col.search.filterType) {
					case '===':
						return data.filter((x) => {
							if (Array.isArray(x[col.name])) return this.search_array(x, col, (query) => query === col.search.keyword.start)
							if (this.isObject(x[col.name])) return this.search_object(x, col, (query) => query === col.search.keyword.start)
							if (col.search.searchFields.some((x) => x === undefined)) p = _.get(x, col.name)
							p = String(p)
							if (col.search.useTranslate)
								p = this.translate(col, p)
							return p && p === col.search.keyword.start
						})

					case 'startWith':
						return data.filter((x) => {
							if (Array.isArray(x[col.name])) return this.search_array(x, col, (query) => query.startsWith(col.search.keyword.start))
							if (this.isObject(x[col.name])) return this.search_object(x, col, (query) => query.startsWith(col.search.keyword.start))
							if (col.search.searchFields.some((x) => x === undefined)) p = _.get(x, col.name)
							p = String(p)
							if (col.search.useTranslate)
								p = this.translate(col, p)
							return p && p.startsWith(col.search.keyword.start)
						})

					case 'endWith':
						return data.filter((x) => {
							if (Array.isArray(x[col.name])) return this.search_array(x, col, (query) => query.endsWith(col.search.keyword.start))
							if (this.isObject(x[col.name])) return this.search_object(x, col, (query) => query.endsWith(col.search.keyword.start))
							if (col.search.searchFields.some((x) => x === undefined)) p = _.get(x, col.name)
							p = String(p)
							if (col.search.useTranslate)
								p = this.translate(col, p)
							return p && p.endsWith(col.search.keyword.start)
						})

					default:
						return data.filter((x) => {
							if (Array.isArray(x[col.name])) return this.search_array(x, col, (query) => query.indexOf(col.search.keyword.start) > -1)
							if (this.isObject(x[col.name])) return this.search_object(x, col, (query) => query.indexOf(col.search.keyword.start) > -1)
							if (col.search.searchFields.some((x) => x === undefined)) p = _.get(x, col.name)
							p = String(p)
							if (col.search.useTranslate)
								p = this.translate(col, p)
							return p && p.indexOf(col.search.keyword.start) > -1
						})
				}
			},
			translate(col, profix) {
				let tempTrans = this.$t(col.search.prefix + col.search.translateSplitter + profix.toLowerCase())
				if (tempTrans == (col.search.prefix + col.search.translateSplitter + profix.toLowerCase()).toString()) tempTrans = this.$t(col.search.prefix + col.search.translateSplitter + profix)
				return tempTrans
			},
			convertDate2Persian(date) {
				return new Date(new Date(date).toLocaleDateString('fa-IR').toString().toEnglishDigits())
			},
			search_pdate(data, col) {
				var num = col.search.keyword.start
					.replace(/[\u0660-\u0669]/g, (c) => {
						return c.charCodeAt(0) - 0x0660
					})
					.replace(/[\u06f0-\u06f9]/g, function (c) {
						return c.charCodeAt(0) - 0x06f0
					})
				num = new Date(num)
				let p = null

				switch (col.search.filterType) {
					case 'after':
						return data.filter((x) => {
							if (Array.isArray(x[col.name])) return this.search_array(x, col, (query) => query < num)
							if (this.isObject(x[col.name])) return this.search_object(x, col, (query) => query < num)
							if (col.search.searchFields.some((x) => x === undefined)) p = _.get(x, col.name)
							if (col.search.keyword.start === '----/--/--') return p
							return p && this.convertDate2Persian(p) < num
						})

					case 'before':
						return data.filter((x) => {
							if (Array.isArray(x[col.name])) return this.search_array(x, col, (query) => query > num)
							if (this.isObject(x[col.name])) return this.search_object(x, col, (query) => query > num)
							if (col.search.searchFields.some((x) => x === undefined)) p = _.get(x, col.name)
							if (col.search.keyword.start === '----/--/--') return p
							return p && this.convertDate2Persian(p) > num
						})
					case 'range':
						let act
						if (!col.search.keyword.start) act = (query) => this.convertDate2Persian(query) < this.convertDate2Persian(col.search.keyword.end)
						else if (!col.search.keyword.end) act = (query) => this.convertDate2Persian(query) > this.convertDate2Persian(col.search.keyword.start)
						else act = (query) => this.convertDate2Persian(col.search.keyword.end) > this.convertDate2Persian(query) && this.convertDate2Persian(query) > this.convertDate2Persian(col.search.keyword.start)
						return data.filter((x) => {
							if (Array.isArray(x[col.name])) return this.search_array(x, col, act)
							if (this.isObject(x[col.name])) return this.search_object(x, col, act)
							if (col.search.searchFields.some((x) => x === undefined)) p = _.get(x, col.name)
							return p && act(p)
						})
					default:
						return data.filter((x) => {
							if (Array.isArray(x[col.name])) return this.search_array(x, col, (query) => query.getTime() === num.getTime())
							if (this.isObject(x[col.name])) return this.search_object(x, col, query.getTime() === num.getTime())
							if (col.search.searchFields.some((x) => x === undefined)) p = _.get(x, col.name)
							if (col.search.keyword.start === '----/--/--') return p
							return p && this.convertDate2Persian(p).getTime() === num.getTime() // equal operators only works with time not with Date Object
						})
				}
			},

			search_number(data, col) {
				var num = parseFloat(col.search.keyword.start)
				if (!num) return data
				let p = null
				switch (col.search.filterType) {
					case '>':
						return data.filter((x) => {
							if (Array.isArray(x[col.name])) return this.search_array(x, col, (query) => parseFloat(query) > num)
							if (this.isObject(x[col.name])) return this.search_object(x, col, (query) => parseFloat(query) > num)
							if (col.search.searchFields.some((x) => x === undefined)) p = _.get(x, col.name)
							return p && parseFloat(p) > num
						})
					case '<':
						return data.filter((x) => {
							if (Array.isArray(x[col.name])) return this.search_array(x, col, (query) => parseFloat(query) < num)
							if (this.isObject(x[col.name])) return this.search_object(x, col, (query) => parseFloat(query) < num)
							if (col.search.searchFields.some((x) => x === undefined)) p = _.get(x, col.name)
							return p && parseFloat(p) < num
						})
					case '>=':
						return data.filter((x) => {
							if (Array.isArray(x[col.name])) return this.search_array(x, col, (query) => parseFloat(query) >= num)
							if (this.isObject(x[col.name])) return this.search_object(x, col, (query) => parseFloat(query) >= num)
							if (col.search.searchFields.some((x) => x === undefined)) p = _.get(x, col.name)
							return p && parseFloat(p) >= num
						})
					case '<=':
						return data.filter((x) => {
							if (Array.isArray(x[col.name])) return this.search_array(x, col, (query) => parseFloat(query) <= num)
							if (this.isObject(x[col.name])) return this.search_object(x, col, (query) => parseFloat(query) <= num)
							if (col.search.searchFields.some((x) => x === undefined)) p = _.get(x, col.name)
							return p && parseFloat(p) <= num
						})
					case 'range':
						let act
						if (!col.search.keyword.start) act = (query) => parseFloat(query) < parseFloat(col.search.keyword.end)
						else if (!col.search.keyword.end) act = (query) => parseFloat(query) > parseFloat(col.search.keyword.start)
						else act = (query) => parseFloat(col.search.keyword.end) > parseFloat(query) && parseFloat(query) > parseFloat(col.search.keyword.start)
						return data.filter((x) => {
							if (Array.isArray(x[col.name])) return this.search_array(x, col, act)
							if (this.isObject(x[col.name])) return this.search_object(x, col, act)
							if (col.search.searchFields.some((x) => x === undefined)) p = _.get(x, col.name)
							return p && act(p)
						})
					default:
						return data.filter((x) => {
							if (Array.isArray(x[col.name])) return this.search_array(x, col, (query) => parseFloat(query) === num)
							if (this.isObject(x[col.name])) return this.search_object(x, col, (query) => parseFloat(query) === num)
							if (col.search.searchFields.some((x) => x === undefined)) p = _.get(x, col.name)
							return p && parseFloat(p) === num
						})
				}
			},
			search_keywordChanged(col) {
				if (col.search && col.search.enabled === true) {
					let index = this.searchedCols.indexOf(col)
					let scroll = false
					if (col.search.keyword && index === -1) {
						this.searchedCols.push(col)
						scroll = true
					} else if ((!col.search.keyword || !col.search.keyword.start) && index > -1) {
						this.searchedCols.splice(index, 1)
						scroll = true
					}

					if (scroll) {
						this.activeRowIndex = 0
						this.col_scrollTo(col)
					}
				}
			},
			search_isTableFiltered() {
				return this.searchedCols.length > 0
			},

			sort_toggle(col) {
				if (!this.col_isSortable(col)) {
					return
				}

				switch (col.sortState) {
					case 'none':
						col.sortState = 'asc'
						break
					case 'asc':
						col.sortState = 'desc'
						break
					default:
						col.sortState = 'none'
						break
				}

				this.focus_setCurrentLocation(
					this.activeRowIndex,
					this.filteredData[this.activeRowIndex],
					col
				)
			},
			sort_multiple(columns) {
				var cols = [...columns]
				var that = this
				return function (obj1, obj2) {
					var result = 0

					for (var i = 0; i < cols.length; i++) {
						result = that.sort_single(cols[i])(obj1, obj2)
						if (result !== 0) {
							break
						}
					}

					return result
				}
			},
			sort_single(col) {
				var that = this
				return function (obj1, obj2) {
					var func
					switch (col.type) {
						case 'number':
						case 'price':
							func = that.sort_number
							break
						case 'text':
						case 'string':
						default:
							func = that.sort_text
							break
					}

					return func(_.get(obj1, col.name), _.get(obj2, col.name), col.sortState)
				}
			},
			sort_text(obj1, obj2, sortState) {
				var sort = {
					first: sortState === 'desc' ? -1 : 1,
					second: sortState !== 'desc' ? -1 : 1,
				}
				return obj1 > obj2 ? sort.first : obj1 < obj2 ? sort.second : 0
			},
			sort_number(obj1, obj2, sortState) {
				var sort = {
					first: sortState === 'desc' ? -1 : 1,
					second: sortState !== 'desc' ? -1 : 1,
				}

				obj1 = parseFloat(obj1)
				obj2 = parseFloat(obj2)

				return obj1 > obj2 ? sort.first : obj1 < obj2 ? sort.second : 0
			},
			sort_sortingCols(includeDefault = false) {
				let sortableCols = this.filteredColumns.filter(
					(x) => x.sortable === true && x.sortState !== 'none'
				)

				if (includeDefault) {
					return [...sortableCols, ...this.settings.defaultSortByCols]
				} else {
					return sortableCols
				}
			},

			filter_init() {
				$(document).click((e) => {
					let $target = $(e.target)
					if (
						!$target.hasClass('btn-filter-toggler') &&
						$target.parents('.filter').length === 0 &&
						$target.parents('.filter-panel-holder').length === 0
					) {
						this.filter_closeFilterPanel()
					}
				})
			},
			filter_switchFilterPanel() {
				this.filterBoxVisible = !this.filterBoxVisible

				if (this.filterBoxVisible) {
					let height = $(this.$el).height()
					if (height >= 500) {
						height = (height / 3) * 2
						let marginTop = -(height + 5)
						$(this.$refs.filterPanel).css({
							height: height,
							'margin-top': marginTop + 'px',
						})
					}
				}
			},
			filter_closeFilterPanel() {
				this.filterBoxVisible = false
			},
			filter_hasFilter(col) {
				let hasFilter = !!this.flattedFilteredItems.filter(
					(x) => x.key === col.name
				).length
				return hasFilter
			},

			pager_prev(manual) {
				return this.pager_move('prev', manual)
			},
			pager_next(manual) {
				return this.pager_move('next', manual)
			},
			pager_itemClicked(item, e) {
				e.preventDefault()

				this.pager_ensureNewRecords().then(() => {
					this.pager_go(item.value - 1, true)
				})
			},
			pager_move(direction, manual) {
				return this.pager_ensureNewRecords()
					.then(() => {
						let sets = this.settings.paging

						if (sets.pageIndex === 0 && direction === 'prev') return
						if (sets.pageIndex === sets.totalPages - 1 && direction === 'next') {
							return
						}
						if (sets._loading === true) return

						sets.pageIndex = sets.pageIndex || 1

						if (direction === 'prev') {
							return this.pager_go(sets.pageIndex - 1, manual)
						} else if (direction === 'next') {
							return this.pager_go(sets.pageIndex + 1, manual)
						}
					})
					.catch((e) => { })
			},
			pager_go(pageIndex, manual) {
				let sets = this.settings.paging

				sets.pageIndex = pageIndex
				sets._loading = true
				let wait = this.$wait(this.$el)

				return new Promise((resolve, reject) => {
					const hasDataSource = this.settings.dataSource != null
					const hasPreparePageResult =
						sets.preparePageRequest != null &&
						_.isFunction(sets.preparePageRequest)

					if (!hasDataSource && !hasPreparePageResult) {
						reject(
							new Error(
								'Unable to load page, either set preparePageRequest or provide a dataSource'
							)
						)
						return
					}

					this.pager_prepare(sets)
						.then((result) => {
							if (hasDataSource) {
								this.init_loadDataSource(result).then(() => {
									this.value_indeterminate(false)
									resolve()
								})
							} else {
								this.init_cloneData(result)
								this.value_indeterminate(false)
								resolve()
							}
						})
						.catch((error) => {
							reject(error)
						})
				}).finally(() => {
					wait.end()

					if (!manual) {
						setTimeout(() => {
							sets._loading = false
						}, 1000)
					} else {
						sets._loading = false
					}
				})
			},
			pager_getItems(data) {
				// #COMPATIBILITY_MODE

				if (data == null) return []

				let props = Object.getOwnPropertyNames(data)
				let pagingDecorated =
					props.filter(
						(x) =>
							x === 'pageIndex' ||
							x === 'pageSize' ||
							x === 'items' ||
							x === 'data'
					).length > 0

				if (!pagingDecorated) return data

				if (data.pageIndex == null && data.pageSize == null) {
					if (data.items != null) {
						return data.items
					} else if (data.data != null) {
						return data.data
					} else {
						return data
					}
				}

				let itemsKey =
					props.filter((x) => x === 'data').length > 0 ? 'data' : 'items'

				_.extendWith(
					this.settings.paging,
					data,
					(objVal, srcVal, key, obj, src) => {
						if (key === itemsKey) {
							return null
						}
					}
				)

				return data[itemsKey]
			},
			pager_ensureNewRecords() {
				return new Promise((resolve, reject) => {
					let newRows = this.row_newRowsCount()
					if (newRows > 0) {
						dialog({
							title: this.$t('notifications.titles-warning'),
							body: this.$t('table.msg.paging.has-new-row', { count: newRows }),
							type: 'warning',
							buttons: [
								{
									title: this.$t('table.msg.paging.has-new-row.ignoreChanges'),
									shortcut: $sc.find('ignore-changes', 'document'),
									isPrimary: true,
									handle: (button, page, e) => {
										resolve()
									},
								},
								{
									title: this.$t('dialog.return'),
									shortcut: $sc.find('return', 'dialog'),
									isCancel: true,
									handle: (button, page, e) => {
										reject(new Error('return'))
									},
								},
							],
						})
					} else {
						resolve()
					}
				})
			},
			pager_prepare(sets) {
				let prepared = sets.preparePageRequest(sets)
				if (prepared.then != null) {
					return prepared
				} else {
					return Promise.resolve(prepared)
				}
			},

			templates_init() {
				g.events.add(document, 'click', this.templates_bodyClicked)
			},
			templates_bodyClicked(sender) {
				// if (!this.$refs.templatesCol) {
				//   return
				// }
				// if (this.templatesIsOpen) {
				//   if (
				//     !$.contains(this.$refs.templatePanel, sender.target)
				//   ) {
				//     this.templatesIsOpen = false
				//   }
				// }

				if (this.templatesIsOpen) {
					this.templates_generate()
				}
			},
			templates_generate() {
				let columns = this.filteredColumns.map((col) => {
					col.clientOffset.basis = col.width

					return {
						id: col.id,
						name: col.name,
						width: this.col_reverseExtractWidth(col.clientOffset),
						pinned: col.pinned,
						sortState: col.sortState,
						visibility: col.visibility,
						order: col.order,
					}
				})

				let tableSettings = {
					searchBarEnabled: this.settings.searchBarEnabled,
				}

				this.currentTemplate = {
					columns,
					tableSettings,
				}
			},
			templates_buttonClicked() {
				this.templatesIsOpen = !this.templatesIsOpen

				if (this.templatesIsOpen) {
					this.templates_generate()
				}
			},
			templates_selectedChanged(template) {
				if (this.headerCategoryLength > 0) {
					this.init_prepareSettings(this.settings)
				} else {
					this.init_prepareSettings(this.options)
				}

				this.defer(() => {
					this.init_footColsWidth()
				}, 1)
			},

			// sort-search-filter
			searchBlur(e) {
				this.preperSearchHandle(e.target)
			},
			selectFilterMode(e) {
				this.activeCol = this.filteredColumns.find(
					(x) => x.id === e.target.getAttribute('col-id')
				)
				this.activeCol.search.filterRemovebtn = true
				this.activeCol.search.filterType = e.target.getAttribute('mode-value')

				this.search_keywordChanged(this.activeCol)
				this.col_applyAllAggregates()
			},
			preperSearchHandle(sender) {
				this.operation = 'filter'
				this.activeCol = this.filteredColumns.find(
					(x) => x.id === sender.getAttribute('col-id')
				)
				if (this.activeCol != null) {
					if (!this.isObject(sender.value)) this.activeCol.search.keyword = { start: sender.value }
					else this.activeCol.search.keyword = sender.value
				}
				this.search_keywordChanged(this.activeCol)
				this.col_applyAllAggregates()
			},
			removeFilter(event) {
				this.preperSearchHandle(event)
			},
			removeAllFilter() {
				const inputs = this.$refs.filterRows.map((comp) => comp.getElement())
				this.$refs.filterRows.map((comp) => comp.isRangeToggler(false))
				const dropdownItems = this.$refs.filterRows.map(
					(comp) => comp.$refs.dropdownItems
				)
				this.searchedCols = []

				for (let index = 0; index < inputs.length; index++) {
					const input = inputs[index]
					if (input.getAttribute('input-name') === 'date') {
						input.value = '----/--/--'
					} else {
						input.value = ''
					}
				}

				for (let index = 0; index < dropdownItems.length; index++) {
					const items = dropdownItems[index]
					if (items != null) {
						for (let index = 0; index < items.children.length; index++) {
							const item = items.children[index]
							if (item.className.includes('active')) {
								item.classList.remove('active')
							}
						}
					}
				}

				for (let index = 0; index < this.filteredColumns.length; index++) {
					const column = this.filteredColumns[index]
					column.search.filterRemovebtn = false
				}

				this.col_applyAllAggregates()
			},
			changeVisibility(column) {
				column.visibility = !column.visibility

				this.defer(() => {
					this.init_footColsWidth()
				}, 1)

				// this.col_applyToColumnByColId(column.id, (cell) => {
				//   if (!column.visibility) {
				//     cell.style['display'] = 'none'
				//     this.init_footColsWidth()
				//   } else {
				//     cell.style['display'] = 'table-cell'
				//     this.init_footColsWidth()
				//   }
				// })

				this.templates_generate()
			},
			aggregateSelected() {
				this.col_applyAllAggregates()
			},
			prepareDropdownFilterItems() {
				this.settings.columns = this.settings.columns.map((col) => {
					let items = col.search.items
					if (col.type === 'dropdown')
						items = this.filteredData.map((f) => f[col.name])
					col.search.items = items
					return col
				})
			},
			hideWait() {
				this.loading = false
			},
			dataOptimizer() {
				let headers = []
				const rows = []
				const result = []

				this.filteredData.forEach((dataRow) => {
					if (dataRow.$___checked) {
						let row = []
						this.filteredColumns.forEach((col) => {
							if (col.visibility) {
								if (typeof dataRow[col.name] === 'object') {
									if (col.view && col.view.options && typeof col.view.options.format === 'function') {
										row.push(col.view.options.format(dataRow[col.name]))
									}
								} else {
									row.push(dataRow[col.name])
								}
							}
						})
						rows.push(row)
					}
				})

				this.filteredColumns.find((col) => {
					if (col.visibility) {
						headers.push(col.title)
					}
				})
				result.push(headers)

				rows.forEach((row) => {
					result.push(row)
				})

				return result
			},
			buildTextFromData(data) {
				let text = ''

				data.forEach((rowItem) => {
					rowItem.forEach((colItem) => {
						text += colItem + '  '
					})
					text += '\r\n'
				})

				return text
			},
			tableCopyRowChecked() {
				const data = this.dataOptimizer()
				const text = this.buildTextFromData(data)

				navigator.clipboard.writeText(text).then(
					() => {
						console.log('Async: Copying to clipboard was successful!')
					},
					(err) => {
						console.error('Async: Could not copy text: ', err)
					}
				)
			},
			loadGridStates() {
				this.gridSettings = this.getActiveState(this.id)
				if (this.gridSettings && this.gridSettings.value) {
					var val = this.gridSettings.value
					this.settings.searchBarEnabled = val.searchBarEnabled
					this.settings.aggregatesEnabled = val.aggregatesEnabled || this.settings.aggregatesEnabled
					this.settings.searchable = val.searchable
				}
			},
			saveGridStates() {
				let aggregatesState = false
				if (!this.gridSettings) {
					this.gridSettings = {
						id: emptyId,
						key: this.id,
						name: this.id.replace('nkGrid_', ''),
						isActive: true,
						rowState: 'new',
					}
				} else {
					this.gridSettings.rowState = 'changed'
					aggregatesState = this.gridSettings.value.aggregatesEnabled
				}

				this.gridSettings.value = {
					searchBarEnabled: this.settings.searchBarEnabled,
					searchable: this.settings.searchable,
					aggregatesEnabled: aggregatesState
				}

				this.modifyStates([this.gridSettings])
				return this.syncStates()
			},
			filterRowVisibility() {
				this.settings.searchBarEnabled = !this.settings.searchBarEnabled
				this.settings.searchable = this.settings.searchBarEnabled

				for (let index = 0; index < this.settings.columns.length; index++) {
					const column = this.settings.columns[index]
					column.search.enabled = this.settings.searchBarEnabled
				}

				this.$nextTick(() => {
					this.init_subscribeSearchKey()
					this.templates_generate()
					this.saveGridStates()
				}, 1)
			},
			aggregateRowVisibility(state) {
				this.settings.aggregatesEnabled = state
				if (!this.settings.aggregatesEnabled) {
					this.settings.aggregatesDefault = false
					this.settings.columns.map((x) => {
						if ((x.aggregates || []).filter((x) => x.isSystem).length == (x.aggregates || []).length)
							x.aggregates = []
					})
				}
				this.$nextTick(() => {
					this.col_applyAllAggregates()
					// this.saveGridStates()
				}, 1)
			},
			init_subscribeSearchKey() {
				if (this.$refs.filterRows && this.$refs.filterRows.length) {
					this.$keyHandler.Subscribe({
						name: 'table-search-start',
						shortcut: {
							keyCode: 13,
						},
						el: this.$refs.filterRows.map((comp) => comp.getElement()),
						context: this,
						handler: function (sender, e) {
							e.preventDefault()
							this.preperSearchHandle(sender)
							return true
						},
					})
				}
			},
			columnsSorting(columns) {
				if (this.headerCategoryLength > 0) {
					columns.sort((a, b) => {
						if (!b.headerCategory) {
							if (a.headerCategory !== b.headerCategory) return -1
							if (a.headerCategory === b.headerCategory) return 1
						} else {
							return 0
						}
					})
				} else {
					columns.sort((a, b) => {
						if (a.order < b.order) return -1
						if (a.order > b.order) return 1
						return 0
					})
				}
			},
			componentClick(button, e) {
				button.handle()
			},
			menu_removeAll() {
				this.value_removeAll()
				if (!this.settings.activeRowDisabled || this.settings.alwaysEmit) {
					this.value_emit()
				}
			},
			menu_addAll() {
				this.value_addAll()
				if (!this.settings.activeRowDisabled || this.settings.alwaysEmit) {
					this.value_emit()
				}
			},
			subscribeKeys() { //ttt
				this.$keyHandler.Subscribe({
					name: 'copy-from-previous',
					keyCode: 67, // C:67
					ctrlKey: true,
					shiftKey: true,
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						e.preventDefault()
						let activeCol = this.activeCol.name

						if (this.activeRowIndex > 0) {
							this.clonedData[this.activeRowIndex][activeCol] = _.cloneDeep(this.clonedData[this.activeRowIndex - 1][activeCol])
							if (Array.isArray(this.clonedData[this.activeRowIndex][activeCol])) {
								for (let item of this.clonedData[this.activeRowIndex][activeCol]) {
									delete item.id
								}
							}
						}
						return true
					},
				})
				this.$keyHandler.Subscribe({
					name: 'table-reselect',
					keyCode: 13, // 13:enter
					el: this.$el,
					context: this,
					test: function (sender, e) {
						if (!this.settings.activeRowDisabled) {
							return false
						}

						if (!this.filteredData[this.activeRowIndex].isSelected) {
							return false
						}

						return true
					},
					handler: function (sender, e) {
						if (!e.ctrlKey) {
							this.value_emit()
							// return true
						}
					},
				}) // table-reselect

				this.$keyHandler.Subscribe({
					name: 'table-arrow-down',
					keyCode: 40, // 40:arrow-down
					ctrlKey: false,
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						e.preventDefault()
						let activeRow = this.filteredData[this.activeRowIndex]
						if (activeRow == null) return

						// select row if active-row is disabled and row not selected
						if (this.settings.activeRowDisabled && !activeRow.isSelected) {
							this.value_add(activeRow, !this.settings.multiselection)
							return true
						}

						// check leave cell
						if (!this.nav_leavingCell(activeRow, this.activeCol, this.filteredData)) {
							return true
						}

						// validate cell
						if (
							!this.validate_isCellValid(
								activeRow,
								this.activeRowIndex,
								this.activeCol
							)
						) {
							activeRow[SYSFIELDS_VALID] = false
							return true
						}

						// check leave row
						if (!this.validate_row(this.activeRowIndex)) {
							activeRow[SYSFIELDS_VALID] = false
							return true
						}

						// leave cell
						this.nav_leaveCell(this.activeRowIndex, this.activeCol)

						// go new row
						let nextIndex = this.activeRowIndex + 1
						let newItemAdded = false
						if (nextIndex >= this.filteredData.length) {
							if (this.row_tryAddEmpty()) {
								newItemAdded = true
							} else {
								return true
							}
						}

						// emit value
						if (!newItemAdded) {
							let nextRow = this.filteredData[nextIndex]
							if (!this.temporaryReadonly) {
								this.value_add(nextRow, true)
							}
						}

						// leave row
						this.activeRowIndex = nextIndex

						if (this.settings.activeRowDisabled) {
							this.focus_selectActiveRow()
						}

						let colIndex = this.filteredColumns.indexOf(this.activeCol)

						if (newItemAdded) {
							colIndex = 0
							activeRow[SYSFIELDS_CHECKED] = false
						}

						this.defer(() => {
							this.focus_nextCellWithDirection(
								this.activeRowIndex,
								colIndex,
								'direct'
							)
							this.focus_focusCurrentLocation()

							if (!this.focus_scrollToActiveRow()) {
								this.focus_scrollPage('down')
							}

							this.focus_scrollToActiveCol()
						}, 50)

						return true
					},
				}) // table-arrow-down

				this.$keyHandler.Subscribe({
					name: 'table-arrow-up',
					keyCode: 38, // 38:arrow-up
					el: this.$el,
					context: this,
					test: function (sender, e) {
						return this.activeRowIndex > 0
					},
					handler: function (sender, e) {
						e.preventDefault()

						var activeRow = this.filteredData[this.activeRowIndex]
						var isEmptyRow = this.row_isEmpty(activeRow)

						if (isEmptyRow && !this.row_deleteAt(this.activeRowIndex)) {
							this.logger.error('oops! unable to delete the row')
							return true
						}

						if (!isEmptyRow) {
							// select row if active-row is disabled and row not selected
							if (this.settings.activeRowDisabled && !activeRow.isSelected) {
								this.value_add(activeRow, !this.settings.multiselection)
								return true
							}

							// check leave cell
							if (!this.nav_leavingCell(activeRow, this.activeCol, this.filteredData)) {
								return true
							}

							// validate cell
							if (
								!this.validate_isCellValid(
									activeRow,
									this.activeRowIndex,
									this.activeCol
								)
							) {
								activeRow[SYSFIELDS_VALID] = false
								return true
							}

							// check leave row
							if (!this.validate_row(this.activeRowIndex)) {
								activeRow[SYSFIELDS_VALID] = false
								return true
							}

							// leave cell
							this.nav_leaveCell(this.activeRowIndex, this.activeCol)
						}

						let nextIndex = this.activeRowIndex - 1

						// emit value
						let nextRow = this.filteredData[nextIndex]
						if (!this.temporaryReadonly) {
							this.value_add(nextRow, true)
						}

						// leave row
						this.activeRowIndex = nextIndex

						if (this.settings.activeRowDisabled) {
							this.focus_selectActiveRow()
						}

						let colIndex = this.filteredColumns.indexOf(this.activeCol)

						this.defer(() => {
							this.focus_nextCellWithDirection(
								this.activeRowIndex,
								colIndex,
								'direct'
							)
							this.focus_focusCurrentLocation()

							if (!this.focus_scrollToActiveRow()) {
								this.focus_scrollPage('up')
							}

							this.focus_scrollToActiveCol()
						}, 50)

						return true
					},
				}) // table-arrow-up

				this.$keyHandler.Subscribe({
					name: 'table-arrow-down-select',
					keyCode: 40, // 40:arrow-down
					shiftKey: true,
					el: this.$el,
					context: this,
					test: function (sender, e) {
						return this.settings.multiselection === true
					},
					handler: function (sender, e) {
						e.preventDefault()

						if (this.isEditable) {
							this.temporaryReadonly = true
						}

						var index = this.activeRowIndex
						if (index < 0) {
							return true
						}

						index += 1 // next row

						if (this.clonedData.length <= index) {
							return true
						}

						var prevRow = this.clonedData[index - 1]
						var nextRow = this.clonedData[index]

						var nextSelected = this.value_any(nextRow)

						if (nextSelected) {
							this.value_remove(prevRow)
						} else {
							this.value_add(prevRow)
							this.value_add(nextRow)
						}

						this.activeRowIndex = index
						this.$nextTick(() => {
							this.defer(this.focus_focusCurrentLocation, 1)
							this.focus_scrollToActiveRow()
						})

						return true
					},
				}) // table-arrow-down-select

				this.$keyHandler.Subscribe({
					name: 'table-arrow-up-select',
					keyCode: 38, // 38:arrow-up
					shiftKey: true,
					el: this.$el,
					context: this,
					test: function (sender, e) {
						return this.settings.multiselection === true
					},
					handler: function (sender, e) {
						e.preventDefault()

						if (this.isEditable) {
							this.temporaryReadonly = true
						}

						var index = this.activeRowIndex
						if (index >= this.clonedData.length) {
							return true
						}

						index -= 1 // next row

						if (index < 0) {
							return true
						}

						var prevRow = this.clonedData[index + 1]
						var nextRow = this.clonedData[index]

						var nextSelected = this.value_any(nextRow)

						if (nextSelected) {
							this.value_remove(prevRow)
						} else {
							this.value_add(prevRow)
							this.value_add(nextRow)
						}

						this.activeRowIndex = index
						this.$nextTick(() => {
							this.defer(this.focus_focusCurrentLocation, 1)
							this.focus_scrollToActiveRow()
						})

						return true
					},
				}) // table-arrow-up-select

				this.$keyHandler.Subscribe({
					name: 'table-arrow-down-move',
					keyCode: 40, // 40:arrow-down
					ctrlKey: true,
					el: this.$el,
					context: this,
					test: function (sender, e) {
						return !this.isEditable && this.settings.multiselection === true
					},
					handler: function (sender, e) {
						e.preventDefault()

						var index = this.activeRowIndex
						if (index < 0) {
							return true
						}

						index += 1 // next row

						if (this.clonedData.length <= index) {
							return true
						}

						this.activeRowIndex = index
						this.defer(this.focus_focusCurrentLocation, 1)
						this.$nextTick(() => {
							this.focus_scrollToActiveRow()
							this.focus_scrollToActiveCol()
						})

						return true
					},
				}) // table-arrow-down-move

				this.$keyHandler.Subscribe({
					name: 'table-arrow-up-move',
					keyCode: 38, // 38:arrow-up
					ctrlKey: true,
					el: this.$el,
					context: this,
					test: function (sender, e) {
						return !this.isEditable && this.settings.multiselection === true
					},
					handler: function (sender, e) {
						e.preventDefault()

						var index = this.activeRowIndex
						if (index >= this.clonedData.length) {
							return true
						}

						index -= 1 // next row

						if (index < 0) {
							return true
						}

						this.activeRowIndex = index
						this.defer(this.focus_focusCurrentLocation, 1)
						this.$nextTick(() => {
							this.focus_scrollToActiveRow()
							this.focus_scrollToActiveCol()
						})

						return true
					},
				}) // table-arrow-up-move

				this.$keyHandler.Subscribe({
					name: `table-arrow-left-${new Date()}`,
					keyCode: [37, 13], // 37:arrow-left 13:enter
					el: this.$el,
					context: this,
					test: function (sender, e) {
						return this.isEditable
					},
					handler: function (sender, e, _this = this) {
						e.preventDefault()
						let isInSearch = $(e.target).parents('.tr-search').length
						if (isInSearch) {
							_this.focus_nextSearchCell('next')
							return true
						}
						let rowIndex = _this.activeRowIndex
						let colIndex = 0
						let needsNextRow = false

						if (rowIndex < 0) {
							if (_this.filteredData.length) {
								rowIndex = 0
							} else {
								return false
							}
						}

						var activeRow = _this.filteredData[rowIndex]
						if (!_this.nav_leavingCell(activeRow, _this.activeCol, this.filteredData)) {
							return true
						}

						if (_this.activeCol && _this.activeCol != null) {
							colIndex = _this.filteredColumns.indexOf(_this.activeCol) + 1
						}

						if (colIndex >= _this.col_getFirstOrLastEditableColumn('last') + 1) {
							colIndex = 0
							needsNextRow = true
						}

						var rowIsValid = _this.validate_isRowValid(_this.activeRowIndex) // recheck all columns
						var cellIsValid = _this.validate_isCellValid(
							activeRow,
							rowIndex,
							_this.activeCol
						)

						if (!rowIsValid && !cellIsValid) {
							// should we stop user in the cell?
						}

						_this.nav_leaveCell(_this.activeRowIndex, _this.activeCol)

						const goNextRow = () => {
							if (!rowIsValid) {
								return true
							}

							let nextRowIndex = rowIndex + 1 // next row
							if (
								_this.filteredData.length <= nextRowIndex &&
								!_this.isEditable &&
								_this.settings.allowNewRow !== true
							) {
								nextRowIndex -= 1
							}

							_this.validate_row(_this.activeRowIndex)

							var inRange = _this.filteredData.length > nextRowIndex
							var newItemAdded = !inRange && _this.row_tryAddEmpty()

							if (inRange || newItemAdded) {
								_this.activeRowIndex = nextRowIndex

								if (!newItemAdded) {
									let nextRow = _this.filteredData[nextRowIndex]
									_this.value_add(nextRow, !_this.settings.multiselection)
								}

								_this.defer(() => {
									_this.focus_focusCurrentLocation()
									_this.focus_scrollToActiveRow()
									_this.focus_scrollToActiveCol()
								}, 150)
							}
						}

						if (needsNextRow && !isInSearch) {
							goNextRow()
						}

						_this.focus_nextCell(rowIndex, colIndex)

						var newColIndex = _this.filteredColumns.indexOf(_this.activeCol)
						if (newColIndex === colIndex - 1) {
							goNextRow()
						}

						return true
					},
				}) // table-arrow-left

				this.$keyHandler.Subscribe({
					name: 'table-arrow-right',
					keyCode: 39, // 39:arrow-right
					el: this.$el,
					context: this,
					test: function (sender, e) {
						return this.isEditable
					},
					handler: function (sender, e) {
						e.preventDefault()

						let isInSearch = $(e.target).parents('.tr-search').length
						if (isInSearch) {
							this.focus_nextSearchCell('previous')
							return true
						}

						var rowIndex = this.activeRowIndex
						var colIndex = 0
						var needsPrevRow = false

						var activeRow = this.filteredData[rowIndex]

						if (!this.nav_leavingCell(activeRow, this.activeCol, this.filteredData)) {
							return true
						}

						if (this.activeCol && this.activeCol != null) {
							colIndex = this.filteredColumns.indexOf(this.activeCol) - 1
						}

						if (colIndex < this.col_getFirstOrLastEditableColumn('first')) {
							colIndex = 0
							needsPrevRow = true
						}

						var rowIsValid = this.validate_isRowValid(rowIndex) // recheck all columns
						var cellIsValid = !this.validate_isCellValid(
							activeRow,
							rowIndex,
							this.activeCol
						)

						if (!rowIsValid && !cellIsValid) {
							// should we stop user in the cell?
						}

						this.nav_leaveCell(rowIndex, this.activeCol)

						if (needsPrevRow && rowIndex > 0) {
							if (!rowIsValid) {
								return true
							}

							rowIndex -= 1
							this.activeRowIndex = rowIndex // previous row
						}

						this.focus_prevCell(rowIndex, colIndex)
						return true
					},
				}) // table-arrow-right

				this.$keyHandler.Subscribe({
					name: 'table-select',
					keyCode: 13, // 13:enter
					el: this.$el,
					context: this,
					test: function (sender, e) {
						return (
							!this.isEditable && this.filteredData.length > this.activeRowIndex
						)
					},
					handler: function (sender, e) {
						e.preventDefault()
						if (!e.ctrlKey) {
							var item = this.filteredData[this.activeRowIndex]
							if (!this.value_any(item)) {
								this.value_add(item, this.settings.multiselection !== true)
							} else if (this.settings.activeRowDisabled) {
								this.value_emit()
							} else {
								this.value_remove(item)
							}

							// return true
						}
					},
				}) // table-select

				this.$keyHandler.Subscribe({
					name: 'table-select-all-in-page',
					keyCode: 65, // 65:A,
					ctrlKey: true,
					el: this.$el,
					context: this,
					test: function (sender, e) {
						return !this.isEditable
					},
					handler: function (sender, e) {
						e.preventDefault()
						this.value_addAll()
						if (!this.settings.activeRowDisabled || this.settings.alwaysEmit) {
							this.value_emit()
						}
						return true
					},
				}) // table-select-all-in-page

				this.$keyHandler.Subscribe({
					name: 'table-select-row-by-space',
					keyCode: 32, // 32:Space,
					ctrlKey: true,
					el: this.$el,
					context: this,
					test: function (sender, e) {
						return !this.isEditable && this.settings.multiselection
					},
					handler: function (sender, e) {
						e.preventDefault()
						this.value_add(this.filteredData[this.activeRowIndex])
						return true
					},
				}) // table-select-all-in-page

				this.$keyHandler.Subscribe({
					name: 'table-revert',
					keyCode: 90, // 90:z
					ctrlKey: true,
					el: this.$el,
					context: this,
					handler: function (sender, e) {
						var originalRow = this.originalData[this.activeRowIndex]
						var clonedRow = this.filteredData[this.activeRowIndex]
						var reverted = false

						if (clonedRow.isDeleted) {
							e.preventDefault()

							var isDirty = clonedRow[SYSFIELDS_DIRTYCELLS].length > 0
							clonedRow.rowState = isDirty ? ROW_CHANGED : ROW_UNCHANGED
							reverted = true
						} else {
							if (this.col_isInDirtyList(clonedRow, this.activeCol.id)) {
								clonedRow[this.activeCol.name] = originalRow[this.activeCol.name]
								clonedRow[SYSFIELDS_DIRTYCELLS].tryRemove(this.activeCol.id)
								reverted = true
							} else if (clonedRow[SYSFIELDS_DIRTYCELLS].length > 0) {
								$.extend(true, clonedRow, originalRow)
								clonedRow[SYSFIELDS_DIRTYCELLS] = []
								reverted = true
							}
						}

						if (reverted) {
							e.preventDefault()
							this.nav_leaveCell(this.activeRowIndex, this.activeCol)
						}

						return true
					},
				}) // table-revert

				this.$keyHandler.Subscribe({
					name: 'table-move-row-down',
					shortcut: $sc.find('move-down', 'table'),
					el: this.$el,
					context: this,
					test: function () {
						return this.isEditable && this.activeRowIndex
					},
					handler: function (sender, e) {
						this.down()
					},
				}) // table-move-row-down

				this.$keyHandler.Subscribe({
					name: 'table-move-row-up',
					shortcut: $sc.find('move-up', 'table'),
					el: this.$el,
					context: this,
					test: function () {
						return this.isEditable && this.activeRowIndex
					},
					handler: function (sender, e) {
						this.up()
					},
				}) // table-move-row-up

				this.$keyHandler.Subscribe({
					name: 'table-duplicate-rows',
					shortcut: $sc.find('copy', 'table'),
					el: this.$el,
					context: this,
					test: function () {
						return this.isEditable && this.activeRowIndex
					},
					handler: function (sender, e) {
						this.duplicateRows()
					},
				}) // table-move-row-up

				// this.$keyHandler.Subscribe({
				// 	name: 'table-insert-empty-row',
				// 	shortcut: $sc.find('insert-new-row', 'table'),
				// 	el: this.$el,
				// 	context: this,
				// 	test: function () {
				// 		return this.isEditable && this.validate_row(this.activeRowIndex)
				// 	},
				// 	handler: function (sender, e) {
				// 		this.row_addNewRow()
				// 	},
				// }), // table-insert-empty-row

				// this.$keyHandler.Subscribe({
				// 	name: 'table-insert-empty-row-at-end',
				// 	shortcut: $sc.find('insert-new-row-at-end', 'table'),
				// 	el: this.$el,
				// 	context: this,
				// 	test: function () {
				// 		return this.isEditable && this.validate_row(this.activeRowIndex)
				// 	},
				// 	handler: function (sender, e) {
				// 		this.row_addRowAtEnd()
				// 	},
				// }), // table-insert-empty-row-at-end

				// this.$keyHandler.Subscribe({
				// 	name: 'table-delete-row',
				// 	shortcut: $sc.find('delete-row', 'table'),
				// 	el: this.$el,
				// 	context: this,
				// 	test: function () {
				// 		if (!this.isEditable) {
				// 			return false
				// 		}

				// 		if (this.settings.prepareDeleteRow != null && _.isFunction(this.settings.prepareDeleteRow)) {
				// 			let row = this.filteredData[this.activeRowIndex]
				// 			return !!this.settings.prepareDeleteRow.call(
				// 				this,
				// 				row,
				// 				this.filteredData
				// 			)
				// 		}

				// 		return true
				// 	},
				// 	handler: function (sender, e) {
				// 		this.row_deleteRow()
				// 	},
				// }) // table-delete-row

				this.$keyHandler.Subscribe({
					name: 'table-page-next',
					shortcut: {
						keyCode: 33, // 33:pageup
					},
					el: this.$el,
					context: this,
					test: () =>
						!!this.settings.paging.enabled &&
						this.settings.paging.pageIndex < this.settings.paging.totalPages - 1,
					handler: function (sender, e) {
						e.preventDefault()
						this.pager_next(true)
						return true
					},
				}) // table-page-next

				this.$keyHandler.Subscribe({
					name: 'table-page-prev',
					shortcut: {
						keyCode: 34, // 34:pagedown
					},
					el: this.$el,
					context: this,
					test: () =>
						!!this.settings.paging.enabled && this.settings.paging.pageIndex > 0,
					handler: function (sender, e) {
						e.preventDefault()
						this.pager_prev(true)
						return true
					},
				}) // table-page-prev

				this.$keyHandler.Subscribe({
					name: 'table-copy',
					shortcut: {
						keyCode: 67, // 67:C
						ctrlKey: true,
						altKey: true,
					},
					el: this.$el,
					context: this,
					test: () => {
						return (
							!this.isEditable &&
							!!this.settings.stateUID &&
							!!this.localValue.length
						)
					},
					handler: function (sender, e) {
						e.preventDefault()
						this.clipboard.copyToClipboard()
						return true
					},
				}) // table-copy

				this.$keyHandler.Subscribe({
					name: 'table-paste',
					shortcut: {
						keyCode: 86, // 86:V
						ctrlKey: true,
						altKey: true,
					},
					el: this.$el,
					context: this,
					test: () =>
						!this.isEditable &&
						!!this.settings.stateUID &&
						!!this.localValue.length,
					handler: function (sender, e) {
						e.preventDefault()
						this.clipboard.pasteFromClipboard()
						return true
					},
				}) // table-paste

				this.$keyHandler.Subscribe({
					name: 'table-copy-row-checked',
					shortcut: {
						keyCode: 67, // 67:C
						ctrlKey: true,
					},
					el: this.$el,
					context: this,
					test: () => {
						return (
							!this.isEditable &&
							!!this.settings.stateUID &&
							!!this.localValue.length
						)
					},
					handler: function (sender, e) {
						e.preventDefault()
						this.tableCopyRowChecked()
						return true
					},
				}) // table-copy-row-checked

				if (this.$refs.filterRows && this.$refs.filterRows.length) {
					this.$keyHandler.Subscribe({
						name: 'table-search-start',
						shortcut: {
							keyCode: 13,
						},
						el: this.$refs.filterRows.map((comp) => comp.getElement()),
						context: this,
						handler: function (sender, e) {
							e.preventDefault()
							this.preperSearchHandle(sender)
							return true
						},
					})
				} // table-search-start

				if (
					this.settings.actions &&
					Array.isArray(this.settings.actions) &&
					this.settings.actions.length > 0
				) {
					const gridId = generateUUID()
					for (var i = this.settings.actions.length - 1; i >= 0; i--) {
						var act = this.settings.actions[i]
						var context = {
							action: act,
							vm: this,
						}

						this.$keyHandler.Subscribe({
							name: `table-customer-action-${act.key || i}-${gridId}`,
							shortcut: act.shortcut,
							el: this.$el,
							context: context,
							handler: function (sender, e) {
								var index = this.vm.activeRowIndex
								var row = this.vm.filteredData[index]

								this.action.handle(
									row,
									index,
									this.vm.filteredData,
									this.vm.activeCol
								)

								for (let col of this.vm.filteredColumns) {
									this.vm.nav_leaveCell(index, col)
								}

								return true
							},
						})
					}
				}
			},
		},
		beforeUnmount() {
			// this.$keyHandler.Unsubscribe('table-arrow-left')
			// this.$keyHandler.Handlers = this.$keyHandler.Handlers.filter(x=>!x.name.includes('table-arrow-left'))
			// const foundEvent = this.$keyHandler.Handlers.find(x => x.name.includes('table-arrow-left'))
			// console.log('foundEvent',foundEvent)
			this.table_FocusCheck('off')
			g.events.clear()
		},
	}
	//  ******** Sample Settings *********
	//  {
	//    stateUID: 'stateID',
	//    mode: 'readonly',
	//    columnsVisibilityEnabled: true,
	//    aggregatesDefault: true,
	//    activeRowDisabled: true,
	//    alwaysEmit: false,
	//    editable: false,
	//    sortable: true,
	//    draggable: true,
	//    droppable: true,
	//    addNewRowOnInit: false,
	//    searchBarEnabled: true,
	//    columns: [
	//      {
	//        name: 'code',
	//        type: 'string', // need for filter row items: 'dropdown', 'string', 'number', 'pdate'
	//        search: {
	//          searchable: false
	//          searchFields: 'name',
	//          useTranslate: bool,
	//          prefix: '' // use prefix for translate
	//        },
	//        title: '',
	//        sortable: true, // fedault = true
	//        draggable: true, // fedault = true
	//        droppable: true, // fedault = true
	//        editable: false,
	//        width: 'auto|>250|<850',
	//        pinnable: true,
	//        pinned: false,
	//        resizable: true,
	//        headerCategory: 'category name',
	// 				aggregates: [
	// 				{
	// 					title: '',
	// 					visible: bool,
	//					order: 0, periority
	//					hideTitle: '',
	//	 				type: 'sum', count - sum - max - min
	//	 				handler: (data, col) => {	},
	//	 			},
	// for pre defined types such as count,sum,max,min you can use only this:
	// 	      {
	//					type: 'count'
	//	      } this will cause visible on init grid
	//    		]
	//  }
</script>
<style src="~/styles/grid.less"
	lang="less"></style>
